(function () {
  'use strict';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function parseIsoDate(isoStr) {
    if (!isoStr) return null;
    var date = new Date(isoStr);
    return isNaN(date.getTime()) ? null : date;
  }

  function parsePromoDate(dateStr, timeStr, period) {
    if (!dateStr) return null;

    var parts = (timeStr || '12:00').split(':');
    var hour = parseInt(parts[0], 10) || 0;
    var minute = parseInt(parts[1], 10) || 0;

    if (period === 'pm' && hour < 12) hour += 12;
    if (period === 'am' && hour === 12) hour = 0;

    var iso = dateStr.trim() + 'T' + pad(hour) + ':' + pad(minute) + ':00';
    var date = new Date(iso);

    return isNaN(date.getTime()) ? null : date;
  }

  function formatCountdown(ms) {
    if (ms <= 0) return null;

    var totalSeconds = Math.floor(ms / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    return days + 'd ' + pad(hours) + 'h ' + pad(minutes) + 'm ' + pad(seconds) + 's';
  }

  function initPromoCountdowns(root) {
    root.querySelectorAll('[data-enova-pdp-promo]').forEach(function (el) {
      var startDate = parseIsoDate(el.dataset.startIso) || parsePromoDate(
        el.dataset.startDate,
        el.dataset.startTime,
        el.dataset.startPeriod
      );
      var endDate = parseIsoDate(el.dataset.endIso) || parsePromoDate(
        el.dataset.endDate,
        el.dataset.endTime,
        el.dataset.endPeriod
      );
      var countdownEl = el.querySelector('[data-enova-pdp-countdown]');
      var prefix = el.dataset.countdownPrefix || 'La promo termina en';
      var expiredText = el.dataset.expiredText || '';

      if (!endDate || !countdownEl) return;

      function tick() {
        var now = new Date();

        if (startDate && now < startDate) {
          el.classList.add('is-hidden');
          return;
        }

        el.classList.remove('is-hidden');

        var remaining = endDate.getTime() - now.getTime();
        var formatted = formatCountdown(remaining);

        if (!formatted) {
          if (expiredText) {
            countdownEl.textContent = expiredText;
          } else {
            el.classList.add('is-hidden');
          }
          return;
        }

        countdownEl.textContent = prefix + ' ' + formatted;
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  function waitForDrawerAnimationEnd(element, fallbackMs) {
    fallbackMs = fallbackMs || 600;

    return new Promise(function (resolve) {
      if (!element) {
        resolve();
        return;
      }

      var done = false;

      function finish() {
        if (done) return;
        done = true;
        element.removeEventListener('animationend', onAnimationEnd);
        resolve();
      }

      function onAnimationEnd(event) {
        if (event.target !== element) return;
        finish();
      }

      element.addEventListener('animationend', onAnimationEnd);
      setTimeout(finish, fallbackMs);
    });
  }

  function openEnovaDrawer(drawer) {
    if (!drawer) return;

    drawer.removeAttribute('closing');

    if (typeof drawer.showModal === 'function') {
      drawer.showModal();
    } else {
      drawer.setAttribute('open', '');
    }

    drawer.removeAttribute('inert');
    document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));
  }

  function closeEnovaDrawer(drawer) {
    if (!drawer || drawer.hasAttribute('inert') || drawer.hasAttribute('closing')) return;

    var animatedEl = drawer.querySelector('.enova-pdp__build-set-drawer-inner')
      || drawer.querySelector('.drawer__inner')
      || drawer;

    drawer.setAttribute('closing', '');

    waitForDrawerAnimationEnd(animatedEl, 550).then(function () {
      if (typeof drawer.close === 'function') {
        drawer.close();
      } else {
        drawer.removeAttribute('open');
      }

      drawer.setAttribute('inert', '');
      drawer.removeAttribute('closing');
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    });
  }

  function bindEnovaDrawer(drawer) {
    if (!drawer || drawer.dataset.enovaDrawerBound) return;
    drawer.dataset.enovaDrawerBound = 'true';

    var closeBtn = drawer.querySelector('[data-popup-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        closeEnovaDrawer(drawer);
      });
    }

    drawer.addEventListener('click', function (event) {
      if (event.target === drawer) closeEnovaDrawer(drawer);
    });

    drawer.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeEnovaDrawer(drawer);
    });
  }

  var STORES_API = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/') + 'apps/apolo-ubigeo-calculation?scope=shop-addresses';

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderStoreListItem(store) {
    var name = escapeHtml(store.name);
    var address = escapeHtml(store.address);

    return ''
      + '<li class="enova-pdp__pickup-store-item">'
      + '<div class="enova-pdp__pickup-store-link">'
      + '<span class="enova-pdp__pickup-store-copy">'
      + '<span class="enova-pdp__pickup-store-name">' + name + '</span>'
      + (address ? '<span class="enova-pdp__pickup-store-address">' + address + '</span>' : '')
      + '</span>'
      + '</div>'
      + '</li>';
  }

  function loadStoresIntoDrawer(drawer, emptyMessage) {
    if (!drawer || drawer.dataset.storesLoaded === 'true') return Promise.resolve();

    var loadingEl = drawer.querySelector('[data-enova-pdp-stores-loading]');
    var panelEl = drawer.querySelector('[data-enova-pdp-stores-panel]');
    var listEl = drawer.querySelector('[data-enova-pdp-stores-list]');
    var emptyEl = drawer.querySelector('[data-enova-pdp-stores-empty]');

    if (loadingEl) loadingEl.hidden = false;
    if (panelEl) panelEl.hidden = true;
    if (listEl) listEl.innerHTML = '';
    if (emptyEl) emptyEl.hidden = true;

    return fetch(STORES_API, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Stores fetch failed');
        return response.json();
      })
      .then(function (data) {
        var stores = (data && data.items) || [];

        if (loadingEl) loadingEl.hidden = true;

        if (!stores.length) {
          if (emptyEl) {
            emptyEl.textContent = emptyMessage || 'No hay tiendas disponibles.';
            emptyEl.hidden = false;
          }
          drawer.dataset.storesLoaded = 'true';
          return;
        }

        if (listEl) {
          listEl.innerHTML = stores.map(renderStoreListItem).join('');
        }
        if (panelEl) panelEl.hidden = false;

        drawer.dataset.storesLoaded = 'true';
      })
      .catch(function () {
        if (loadingEl) loadingEl.hidden = true;
        if (emptyEl) {
          emptyEl.textContent = emptyMessage || 'No se pudieron cargar las tiendas.';
          emptyEl.hidden = false;
        }
        drawer.dataset.storesLoaded = 'true';
      });
  }

  function initStorePickup(root) {
    root.querySelectorAll('[data-enova-pdp-pickup]').forEach(function (wrap) {
      var trigger = wrap.querySelector('[data-enova-pdp-pickup-trigger]');
      var pickup = wrap.querySelector('pickup-availability');
      var drawerTitle = wrap.dataset.drawerTitle;
      var fallbackDrawerId = wrap.dataset.fallbackDrawerId;
      var emptyMessage = wrap.dataset.emptyMessage;
      var fallbackDrawer = fallbackDrawerId ? root.querySelector('#' + fallbackDrawerId) : root.querySelector('[data-enova-pdp-pickup-fallback]');
      if (!trigger) return;

      function applyDrawerTitle(drawer) {
        if (!drawerTitle || !drawer) return;
        var heading = drawer.querySelector('#PickupAvailabilityHeading')
          || drawer.querySelector('.enova-pdp__drawer-title')
          || drawer.querySelector('[id$="-heading"]');
        if (heading) heading.textContent = drawerTitle;
      }

      function relocatePickupDrawer(drawer) {
        if (!drawer || drawer.dataset.enovaRelocated === 'true') return drawer;

        if (!drawer.id) {
          drawer.id = 'EnovaPdpPickupDrawer--' + root.dataset.sectionId;
        }

        root.appendChild(drawer);
        drawer.dataset.enovaRelocated = 'true';
        return drawer;
      }

      function getNativeDrawer() {
        if (!pickup) return null;

        var drawer = pickup.querySelector('[data-pickup-drawer]');
        if (!drawer) {
          drawer = root.querySelector('[data-pickup-drawer][data-enova-relocated="true"]');
        }

        return relocatePickupDrawer(drawer);
      }

      function isNativePickupSettled() {
        if (!pickup) return true;
        if (pickup.querySelector('[data-pickup-drawer]')) return true;
        if (pickup.classList.contains('hidden')) return true;
        return pickup.dataset.enovaFetchSettled === 'true';
      }

      function openCustomStoresDrawer() {
        if (!fallbackDrawer) return false;

        applyDrawerTitle(fallbackDrawer);
        bindEnovaDrawer(fallbackDrawer);
        openEnovaDrawer(fallbackDrawer);
        loadStoresIntoDrawer(fallbackDrawer, emptyMessage);
        return true;
      }

      function openNativeDrawer() {
        var nativeDrawer = getNativeDrawer();
        applyDrawerTitle(nativeDrawer);

        if (nativeDrawer) {
          if (pickup && pickup.popupActions && typeof pickup.popupActions.popupOpen === 'function') {
            pickup.popupActions.popupOpen();
          } else {
            bindEnovaDrawer(nativeDrawer);
            openEnovaDrawer(nativeDrawer);
          }
          return true;
        }

        if (pickup) {
          var nativeBtn = pickup.querySelector('[data-popup-open]');
          if (nativeBtn) {
            nativeBtn.click();
            return true;
          }
        }

        return false;
      }

      function openPickupDrawer(attempt) {
        attempt = attempt || 0;

        if (!isNativePickupSettled() && attempt < 12) {
          window.setTimeout(function () {
            openPickupDrawer(attempt + 1);
          }, 250);
          return true;
        }

        if (openNativeDrawer()) return true;
        return openCustomStoresDrawer();
      }

      function onPickupReady() {
        var nativeDrawer = getNativeDrawer();
        if (nativeDrawer) {
          applyDrawerTitle(nativeDrawer);
          bindEnovaDrawer(nativeDrawer);
        }
      }

      function markPickupSettled() {
        if (!pickup) return;
        pickup.dataset.enovaFetchSettled = 'true';
        onPickupReady();
      }

      trigger.addEventListener('click', function () {
        openPickupDrawer(0);
      });

      if (pickup) {
        var observer = new MutationObserver(function () {
          markPickupSettled();
          onPickupReady();
        });
        observer.observe(pickup, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
        window.setTimeout(markPickupSettled, 4000);
        onPickupReady();
      }

      if (fallbackDrawer) {
        bindEnovaDrawer(fallbackDrawer);
        loadStoresIntoDrawer(fallbackDrawer, emptyMessage);
      }
    });
  }

  function initCartBar(root) {
    var cartBar = root.querySelector('[data-enova-pdp-cart-bar]');
    if (!cartBar) return;

    var ctas = root.querySelector('[data-enova-pdp-atc]');
    if (!ctas) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          cartBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0, rootMargin: '0px 0px -40px 0px' }
    );

    observer.observe(ctas);

    var scrollBtn = cartBar.querySelector('[data-enova-pdp-cart-scroll]');
    if (scrollBtn) {
      scrollBtn.addEventListener('click', function () {
        ctas.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    var addBtn = cartBar.querySelector('[data-add-to-cart-bar]');
    if (addBtn) {
      var resetTimer = null;

      function setBarState(state) {
        addBtn.classList.toggle('is-loading', state === 'loading');
        addBtn.classList.toggle('is-added', state === 'added');
        addBtn.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
        if (state === 'loading') addBtn.disabled = true;
      }

      addBtn.addEventListener('click', function () {
        var mainBtn = root.querySelector('[data-enova-pdp-atc] [data-add-to-cart]');
        if (!mainBtn || mainBtn.disabled || addBtn.classList.contains('is-loading')) return;

        clearTimeout(resetTimer);
        setBarState('loading');

        // El botón de la barra da la confirmación: se corta el toast del monto mínimo
        // (theme:product:added:below_min) que aparecía encima de la barra.
        function stopToast(event) {
          event.stopImmediatePropagation();
        }
        window.addEventListener('theme:product:added:below_min', stopToast, true);

        function finish(ok) {
          mainBtn.removeEventListener('theme:product:add', onAdded);
          mainBtn.removeEventListener('theme:product:add-error', onError);
          window.setTimeout(function () {
            window.removeEventListener('theme:product:added:below_min', stopToast, true);
          }, 1500);

          setBarState(ok ? 'added' : '');
          var variantAvailable = !mainBtn.disabled || mainBtn.classList.contains('is-loading');
          addBtn.disabled = !variantAvailable;
          if (ok) {
            resetTimer = window.setTimeout(function () {
              setBarState('');
            }, 2200);
          }
        }
        function onAdded() { finish(true); }
        function onError() { finish(false); }

        mainBtn.addEventListener('theme:product:add', onAdded);
        mainBtn.addEventListener('theme:product:add-error', onError);
        // Red de seguridad por si el tema no responde
        window.setTimeout(function () {
          if (addBtn.classList.contains('is-loading')) finish(false);
        }, 10000);

        mainBtn.click();
      });
    }
  }

  /* Gallery del PDP como slider (igual intencion que el slider de banners del
     home): el <product-images> nativo (fader que cruza clases/atributos, no
     hace scroll real) se deja intacto -no se toca su logica de zoom/variantes/
     miniaturas-, y se le suma encima: flechas prev/next, paginador clickeable,
     y una animacion de deslizamiento (translateX) con direccion correcta segun
     a que slide se salta. No se reusan las clases nativas de Flickity del home
     porque sus flechas se ocultan en mobile (display:none <=749px), que es
     justo donde mas se usa esta galeria. */
  function initGallerySlider(root) {
    root.querySelectorAll('[data-enova-pdp-gallery-dots]').forEach(function (dotsEl) {
      var gallery = dotsEl.closest('.enova-pdp__gallery');
      var productImages = dotsEl.closest('product-images');
      if (!productImages || !gallery) return;

      var dots = dotsEl.querySelectorAll('.enova-pdp__gallery-dot');
      var slides = Array.prototype.slice.call(productImages.querySelectorAll('[data-image-id]'));

      function mediaIndex(mediaId) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === mediaId) return i;
        }
        return -1;
      }

      function syncActive(oldId, newId) {
        dots.forEach(function (dot) {
          dot.classList.toggle('is-active', dot.dataset.mediaId === newId);
        });

        if (oldId && newId && oldId !== newId) {
          var oldIndex = mediaIndex(oldId);
          var newIndex = mediaIndex(newId);
          var isAdjacentNext = slides[oldIndex] && slides[oldIndex].nextElementSibling === slides[newIndex];
          var isAdjacentPrev = slides[oldIndex] && slides[oldIndex].previousElementSibling === slides[newIndex];
          var isWrapNext = oldIndex === slides.length - 1 && newIndex === 0;
          var isWrapPrev = oldIndex === 0 && newIndex === slides.length - 1;
          var direction = 'next';
          if (isAdjacentPrev || isWrapPrev) direction = 'prev';
          else if (isAdjacentNext || isWrapNext) direction = 'next';
          else direction = newIndex > oldIndex ? 'next' : 'prev';

          gallery.setAttribute('data-slide-direction', direction);
        }
      }

      syncActive(null, productImages.getAttribute('data-active-media'));

      var observer = new MutationObserver(function (mutations) {
        var mutation = mutations[mutations.length - 1];
        syncActive(mutation.oldValue, productImages.getAttribute('data-active-media'));
      });
      observer.observe(productImages, { attributes: true, attributeFilter: ['data-active-media'], attributeOldValue: true });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          productImages.selectMedia(dot.dataset.mediaId);
        });
      });

      var prevBtn = gallery.querySelector('[data-enova-pdp-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-enova-pdp-gallery-next]');
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          productImages.showPreviousImage();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          productImages.showNextImage();
        });
      }
    });
  }

  function initInfoDrawer(root) {
    var drawer = root.querySelector('[data-enova-pdp-info-drawer]');
    if (!drawer) return;

    function openDrawer(targetId) {
      openEnovaDrawer(drawer);

      var collapsibleRoot = drawer.querySelector('collapsible-elements');
      drawer.querySelectorAll('[data-info-panel]').forEach(function (panel) {
        if (collapsibleRoot && typeof collapsibleRoot.close === 'function' && panel.hasAttribute('open')) {
          collapsibleRoot.close(panel);
        } else {
          panel.removeAttribute('open');
          var body = panel.querySelector('[data-collapsible-body]');
          if (body) body.style.height = '';
        }
      });

      if (targetId) {
        var targetPanel = drawer.querySelector('[data-info-panel="' + targetId + '"]');
        if (targetPanel) {
          if (collapsibleRoot && typeof collapsibleRoot.open === 'function') {
            collapsibleRoot.open(targetPanel);
          } else {
            targetPanel.setAttribute('open', 'true');
          }
        }
      }
    }

    bindEnovaDrawer(drawer);

    root.querySelectorAll('[data-enova-pdp-info-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openDrawer(trigger.dataset.target);
      });
    });
  }

  function refreshThemeCartAfterAdd() {
    var cartItemsEl = document.querySelector('cart-items');

    if (!cartItemsEl || typeof cartItemsEl.getCart !== 'function') {
      document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));
      return;
    }

    cartItemsEl._pendingAddToCart = true;

    if (cartItemsEl.cart && cartItemsEl.cart.classList) {
      cartItemsEl.cart.classList.add('is-loading');
    }

    cartItemsEl.getCart();
  }

  /* Reutilizado por "Arma tu set" y "Shop the look": pinta el botón "agregar
     todo" según su estado. En reposo muestra la etiqueta + contador de
     seleccionados; mientras se agrega al carrito cambia a "Agregando..." y se
     deshabilita para que el usuario tenga claro en qué estado está. */
  function renderAddAllButton(btn, textEl, idleLabel, loadingLabel, selectedCount) {
    if (!btn) return;

    if (btn.dataset.loading === 'true') {
      if (textEl) textEl.textContent = loadingLabel;
      btn.classList.add('is-ready');
      btn.classList.add('is-loading');
      btn.disabled = true;
      return;
    }

    btn.classList.remove('is-loading');
    var suffix = selectedCount > 0 ? ' (' + selectedCount + ')' : '';
    if (textEl) textEl.textContent = idleLabel + suffix;
    btn.classList.toggle('is-ready', selectedCount > 0);
    btn.disabled = selectedCount <= 0;
  }

  function initBuildSet(root) {
    var drawer = root.querySelector('[data-enova-pdp-build-set-drawer]');
    var trigger = root.querySelector('[data-enova-pdp-build-set-trigger]');
    if (!drawer || !trigger) return;

    bindEnovaDrawer(drawer);

    var detailDrawer = root.querySelector('[data-enova-pdp-build-set-detail-drawer]');
    var detailContentEl = detailDrawer && detailDrawer.querySelector('[data-build-set-detail-content]');
    var detailAddBtn = detailDrawer && detailDrawer.querySelector('[data-build-set-detail-add]');
    var activeDetailCard = null;

    if (detailDrawer) bindEnovaDrawer(detailDrawer);

    function getDefaultBuildSetQty(card) {
      if (card.hasAttribute('data-build-set-current-product')) {
        var defaultQty = parseInt(card.dataset.buildSetDefaultQty, 10);
        return isNaN(defaultQty) ? 1 : defaultQty;
      }

      return 0;
    }

    function getCurrentBuildSetVariantsMap() {
      var el = drawer.querySelector('[data-build-set-current-variants]');
      if (!el) return {};

      try {
        return JSON.parse(el.textContent);
      } catch (error) {
        return {};
      }
    }

    function formatBuildSetMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';
        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      return String((cents || 0) / 100);
    }

    function syncCurrentBuildSetProduct(variant) {
      var card = drawer.querySelector('[data-build-set-current-product]');
      if (!card || !variant) return;

      var variantsMap = getCurrentBuildSetVariantsMap();
      var variantData = variantsMap[String(variant.id)] || {};
      var maxQty = variantData.max_quantity != null ? variantData.max_quantity : 9999;

      card.dataset.variantId = String(variant.id);
      card.dataset.available = variant.available ? 'true' : 'false';
      card.dataset.maxQuantity = String(maxQty);
      card.dataset.inventoryManaged = variantData.inventory_managed ? 'true' : 'false';
      card.dataset.buildSetDefaultQty = variant.available && maxQty > 0 ? '1' : '0';
      delete card.dataset.effectiveMaxQuantity;

      var priceEl = card.querySelector('[data-build-set-current-price]');
      if (priceEl && variant.price != null) {
        priceEl.textContent = formatBuildSetMoney(variant.price);
      }

      var imageEl = card.querySelector('[data-build-set-current-image]');
      if (imageEl && variantData.image) {
        imageEl.src = variantData.image;
      }

      var qtyValueEl = card.querySelector('[data-build-set-qty-value]');
      if (qtyValueEl) {
        var qty = parseInt(qtyValueEl.textContent, 10) || 0;
        var defaultQty = getDefaultBuildSetQty(card);

        if (!variant.available || maxQty === 0) {
          qtyValueEl.textContent = '0';
        } else if (qty === 0 && defaultQty > 0) {
          qtyValueEl.textContent = String(defaultQty);
        }
      }

      updateProductCard(card);
      updateAddAllState();
    }

    function resetBuildSetQuantities() {
      drawer.querySelectorAll('[data-build-set-product]').forEach(function (card) {
        var qtyValueEl = card.querySelector('[data-build-set-qty-value]');
        if (qtyValueEl) qtyValueEl.textContent = String(getDefaultBuildSetQty(card));
        delete card.dataset.effectiveMaxQuantity;
        updateProductCard(card);
      });
    }

    function getEffectiveMax(card) {
      var effective = card.dataset.effectiveMaxQuantity;
      if (effective !== undefined && effective !== '') {
        var parsedEffective = parseInt(effective, 10);
        if (!isNaN(parsedEffective)) return parsedEffective;
      }

      var max = parseInt(card.dataset.maxQuantity, 10);
      return isNaN(max) ? 9999 : max;
    }

    function syncDetailAddButton() {
      if (!detailAddBtn || !activeDetailCard) return;

      var available = activeDetailCard.dataset.available !== 'false';
      var maxQty = getEffectiveMax(activeDetailCard);
      var qtyValueEl = activeDetailCard.querySelector('[data-build-set-qty-value]');
      var qty = parseInt(qtyValueEl ? qtyValueEl.textContent : '0', 10) || 0;
      var soldOut = !available || maxQty === 0;

      detailAddBtn.disabled = soldOut || qty >= maxQty;
      detailAddBtn.querySelector('.enova-pdp__btn-label').textContent = soldOut ? 'Agotado' : 'Agregar';
    }

    function initDetailGallery(container) {
      var gallery = container.querySelector('[data-build-set-detail-gallery]');
      if (!gallery) return;

      var track = gallery.querySelector('[data-build-set-detail-gallery-track]');
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-build-set-detail-gallery-slide]'));
      var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-build-set-detail-gallery-dot]'));
      var prevBtn = gallery.querySelector('[data-build-set-detail-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-build-set-detail-gallery-next]');
      if (!track || slides.length < 2) return;

      var currentIndex = 0;

      function goToSlide(index) {
        index = Math.max(0, Math.min(slides.length - 1, index));
        slides[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }

      function setActive(index) {
        currentIndex = index;

        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });

        if (prevBtn) prevBtn.disabled = index === 0;
        if (nextBtn) nextBtn.disabled = index === slides.length - 1;
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          goToSlide(index);
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goToSlide(currentIndex - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goToSlide(currentIndex + 1);
        });
      }

      setActive(0);

      if (typeof IntersectionObserver !== 'function') return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.6) return;
          var index = slides.indexOf(entry.target);
          if (index !== -1) setActive(index);
        });
      }, { root: track, threshold: [0.6] });

      slides.forEach(function (slide) {
        observer.observe(slide);
      });
    }

    function openBuildSetDetail(card) {
      var template = card.querySelector('[data-build-set-detail-template]');
      if (!template || !detailContentEl || !detailDrawer) return;

      activeDetailCard = card;
      detailContentEl.innerHTML = '';
      detailContentEl.appendChild(template.content.cloneNode(true));
      initDetailGallery(detailContentEl);
      syncDetailAddButton();
      openEnovaDrawer(detailDrawer);
    }

    function refreshInventoryFromCart() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          drawer.querySelectorAll('[data-build-set-product]').forEach(function (card) {
            var variantId = parseInt(card.dataset.variantId, 10);
            var baseMax = parseInt(card.dataset.maxQuantity, 10);
            if (isNaN(baseMax)) baseMax = 9999;

            var inCart = 0;
            if (cart && cart.items) {
              cart.items.forEach(function (item) {
                if (item.variant_id === variantId) inCart += item.quantity;
              });
            }

            var managed = card.dataset.inventoryManaged === 'true';
            var effectiveMax = managed ? Math.max(0, baseMax - inCart) : baseMax;
            card.dataset.effectiveMaxQuantity = String(effectiveMax);

            var qtyValueEl = card.querySelector('[data-build-set-qty-value]');
            var qty = parseInt(qtyValueEl ? qtyValueEl.textContent : '0', 10) || 0;
            if (qty > effectiveMax && qtyValueEl) {
              qtyValueEl.textContent = String(effectiveMax);
            }

            updateProductCard(card);
          });

          updateAddAllState();
        })
        .catch(function () {});
    }

    function updateProductCard(card) {
      var qtyValueEl = card.querySelector('[data-build-set-qty-value]');
      var badgeEl = card.querySelector('[data-build-set-badge]');
      var mediaEl = card.querySelector('[data-build-set-media]');
      var visualEl = card.querySelector('[data-build-set-visual]');
      var minusBtn = card.querySelector('[data-build-set-qty-minus]');
      var plusBtn = card.querySelector('[data-build-set-qty-plus]');
      var qty = parseInt(qtyValueEl ? qtyValueEl.textContent : '0', 10) || 0;
      var available = card.dataset.available !== 'false';
      var maxQty = getEffectiveMax(card);
      var isSelected = qty > 0;
      var canIncrease = available && qty < maxQty;

      if (qtyValueEl) qtyValueEl.textContent = String(qty);

      if (badgeEl) {
        badgeEl.textContent = String(qty);
        badgeEl.hidden = !isSelected;
      }

      if (mediaEl) {
        mediaEl.classList.toggle('is-selected', isSelected);
      }

      if (visualEl) {
        visualEl.classList.toggle('is-selected', isSelected);
      }

      card.classList.toggle('is-selected', isSelected);

      if (minusBtn) minusBtn.disabled = qty <= 0;
      if (plusBtn) plusBtn.disabled = !canIncrease;
      card.classList.toggle('is-max-qty', qty >= maxQty && maxQty > 0);
      card.classList.toggle('is-stock-limited', maxQty === 0 && available);
    }

    function updateAddAllState() {
      var addAllBtn = drawer.querySelector('[data-build-set-add-all]');
      if (!addAllBtn) return;

      var selectedCount = 0;
      drawer.querySelectorAll('[data-build-set-product]').forEach(function (card) {
        var qty = parseInt(card.querySelector('[data-build-set-qty-value]')?.textContent || '0', 10) || 0;
        if (qty > 0) selectedCount += 1;
      });

      renderAddAllButton(
        addAllBtn,
        addAllBtn.querySelector('[data-build-set-add-all-text]'),
        addAllBtn.dataset.buildSetAddAllLabel || addAllBtn.textContent.trim(),
        addAllBtn.dataset.buildSetAddAllLoadingLabel || 'Agregando...',
        selectedCount
      );
    }

    trigger.addEventListener('click', function () {
      openEnovaDrawer(drawer);
      refreshInventoryFromCart();
    });

    function getCartAddUrl() {
      var rootUrl = (window.theme && window.theme.routes && window.theme.routes.root)
        || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        || '/';
      return rootUrl.replace(/\/?$/, '/') + 'cart/add.js';
    }

    drawer.querySelectorAll('[data-build-set-product]').forEach(function (card) {
      var minusBtn = card.querySelector('[data-build-set-qty-minus]');
      var plusBtn = card.querySelector('[data-build-set-qty-plus]');
      var qtyValueEl = card.querySelector('[data-build-set-qty-value]');

      if (plusBtn) {
        plusBtn.addEventListener('click', function (event) {
          event.stopPropagation();
          var qty = parseInt(qtyValueEl.textContent || '0', 10) || 0;
          var maxQty = getEffectiveMax(card);
          if (qty >= maxQty) return;
          qtyValueEl.textContent = String(qty + 1);
          updateProductCard(card);
          updateAddAllState();
        });
      }

      if (minusBtn) {
        minusBtn.addEventListener('click', function (event) {
          event.stopPropagation();
          var qty = parseInt(qtyValueEl.textContent || '0', 10) || 0;
          if (qty <= 0) return;
          qtyValueEl.textContent = String(qty - 1);
          updateProductCard(card);
          updateAddAllState();
        });
      }

      updateProductCard(card);

      var detailTrigger = card.querySelector('[data-build-set-detail-trigger]');
      if (detailTrigger) {
        detailTrigger.addEventListener('click', function (event) {
          event.stopPropagation();
          openBuildSetDetail(card);
        });
      }

      card.addEventListener('click', function (event) {
        if (card.hasAttribute('data-build-set-current-product')) return;
        if (event.target.closest('[data-build-set-qty-minus], [data-build-set-qty-plus], [data-build-set-detail-trigger]')) return;

        var qty = parseInt(qtyValueEl.textContent || '0', 10) || 0;
        var maxQty = getEffectiveMax(card);
        if (qty === 0 && plusBtn && !plusBtn.disabled && maxQty > 0) {
          qtyValueEl.textContent = '1';
          updateProductCard(card);
          updateAddAllState();
        }
      });
    });

    if (detailAddBtn) {
      detailAddBtn.addEventListener('click', function () {
        if (!activeDetailCard || detailAddBtn.disabled) return;

        var qtyValueEl = activeDetailCard.querySelector('[data-build-set-qty-value]');
        var maxQty = getEffectiveMax(activeDetailCard);
        var qty = parseInt(qtyValueEl ? qtyValueEl.textContent : '0', 10) || 0;

        if (qty < maxQty) {
          qtyValueEl.textContent = String(qty + 1);
          updateProductCard(activeDetailCard);
          updateAddAllState();
        }

        closeEnovaDrawer(detailDrawer);
      });
    }

    function getBuildSetMessageEl() {
      return drawer.querySelector('[data-build-set-message]');
    }

    function showBuildSetMessage(text, isSuccess) {
      var el = getBuildSetMessageEl();
      if (!el) return;
      el.textContent = text;
      el.hidden = false;
      el.classList.toggle('enova-pdp__build-set-message--success', !!isSuccess);
    }

    function hideBuildSetMessage() {
      var el = getBuildSetMessageEl();
      if (!el) return;
      el.hidden = true;
    }

    function getCardTitle(card) {
      var titleEl = card.querySelector('.enova-pdp__build-set-product-title');
      return titleEl ? titleEl.textContent.trim() : 'un producto';
    }

    function markCardSoldOut(card) {
      var qtyValueEl = card.querySelector('[data-build-set-qty-value]');
      if (qtyValueEl) qtyValueEl.textContent = '0';
      card.dataset.effectiveMaxQuantity = '0';
      card.classList.add('enova-pdp__build-set-product--sold-out');
      updateProductCard(card);
    }

    /* Trazabilidad: marca de origen para reportes (linea + carrito completo).
       _origen queda oculto para el cliente en carrito/checkout (prefijo _)
       pero visible en el Admin y via API. */
    var BUILD_SET_ORIGIN_PROPERTY = { _origen: 'arma-tu-set' };
    var BUILD_SET_CART_ATTRIBUTE = { 'Incluye Arma tu set': 'true' };

    function markCartAsBuildSetOrigin() {
      var rootUrl = (window.theme && window.theme.routes && window.theme.routes.root)
        || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        || '/';
      fetch(rootUrl.replace(/\/?$/, '/') + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: BUILD_SET_CART_ATTRIBUTE }),
      }).catch(function () { /* noop: no bloquea el flujo de compra */ });
    }

    function addSingleItem(variantId, quantity) {
      return fetch(getCartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity, properties: BUILD_SET_ORIGIN_PROPERTY }] }),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok && !data.status, data: data };
          });
        })
        .catch(function (err) {
          return { ok: false, data: err };
        });
    }

    /* Fallback cuando el lote falla: Shopify rechaza el POST completo si UN
       item no tiene stock suficiente. Reintentar uno por uno permite que los
       productos disponibles sí se agreguen, y avisa cual fallo por nombre. */
    function addItemsSequentially(entries) {
      var succeeded = [];
      var failed = [];

      function next(i) {
        if (i >= entries.length) {
          return Promise.resolve({ succeeded: succeeded, failed: failed });
        }
        var entry = entries[i];
        return addSingleItem(entry.variantId, entry.quantity).then(function (result) {
          if (result.ok) {
            succeeded.push(entry);
          } else {
            failed.push(entry);
            markCardSoldOut(entry.card);
          }
          return next(i + 1);
        });
      }

      return next(0);
    }

    var addAllBtn = drawer.querySelector('[data-build-set-add-all]');
    if (addAllBtn) {
      addAllBtn.addEventListener('click', function () {
        var items = [];
        var entries = [];

        drawer.querySelectorAll('[data-build-set-product]').forEach(function (card) {
          var qtyValueEl = card.querySelector('[data-build-set-qty-value]');
          var qty = parseInt(qtyValueEl ? qtyValueEl.textContent : '0', 10) || 0;
          var variantId = parseInt(card.dataset.variantId, 10);
          var maxQty = getEffectiveMax(card);

          if (qty > maxQty) {
            qty = maxQty;
            if (qtyValueEl) qtyValueEl.textContent = String(qty);
            updateProductCard(card);
          }

          if (qty > 0 && variantId) {
            items.push({ id: variantId, quantity: qty, properties: BUILD_SET_ORIGIN_PROPERTY });
            entries.push({ card: card, variantId: variantId, quantity: qty, title: getCardTitle(card) });
          }
        });

        if (!items.length || addAllBtn.dataset.loading === 'true') return;

        hideBuildSetMessage();
        addAllBtn.dataset.loading = 'true';
        updateAddAllState();

        fetch(getCartAddUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify({ items: items }),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            if (data && data.status) {
              throw data;
            }

            resetBuildSetQuantities();
            updateAddAllState();

            closeEnovaDrawer(drawer);
            refreshThemeCartAfterAdd();
            markCartAsBuildSetOrigin();
          })
          .catch(function () {
            /* El lote fallo (probablemente stock insuficiente en algun item).
               Reintentar uno por uno para no bloquear a los que si tienen stock. */
            return addItemsSequentially(entries).then(function (result) {
              result.succeeded.forEach(function (entry) {
                var qtyValueEl = entry.card.querySelector('[data-build-set-qty-value]');
                if (qtyValueEl) qtyValueEl.textContent = String(getDefaultBuildSetQty(entry.card));
                updateProductCard(entry.card);
              });

              if (result.succeeded.length) {
                refreshThemeCartAfterAdd();
                markCartAsBuildSetOrigin();
              }

              if (result.failed.length && result.succeeded.length) {
                var failedNames = result.failed.map(function (e) { return e.title; }).join(', ');
                showBuildSetMessage(
                  'Se agregaron ' + result.succeeded.length + ' producto(s). "' + failedNames + '" ya no tiene stock disponible y se quitó de tu selección.',
                  false
                );
              } else if (result.failed.length) {
                var allFailedNames = result.failed.map(function (e) { return e.title; }).join(', ');
                showBuildSetMessage('"' + allFailedNames + '" ya no tiene stock disponible. Actualiza tu selección e intenta de nuevo.', false);
              } else {
                closeEnovaDrawer(drawer);
              }

              updateAddAllState();
            });
          })
          .finally(function () {
            delete addAllBtn.dataset.loading;
            updateAddAllState();
          });
      });
    }

    updateAddAllState();

    root.addEventListener('theme:variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      syncCurrentBuildSetProduct(variant);
    });
  }

  function initShopLook(root) {
    var drawer = root.querySelector('[data-enova-pdp-shop-look-drawer]');
    var trigger = root.querySelector('[data-enova-pdp-shop-look-trigger]');
    if (!drawer || !trigger) return;

    bindEnovaDrawer(drawer);

    var detailDrawer = root.querySelector('[data-enova-pdp-shop-look-detail-drawer]');
    var detailContentEl = detailDrawer && detailDrawer.querySelector('[data-shop-look-detail-content]');
    var detailAddBtn = detailDrawer && detailDrawer.querySelector('[data-shop-look-detail-add]');
    var activeDetailCard = null;

    if (detailDrawer) bindEnovaDrawer(detailDrawer);

    function getDefaultQty(card) {
      var defaultQty = parseInt(card.dataset.defaultQty, 10);
      return isNaN(defaultQty) ? 0 : defaultQty;
    }

    function getEffectiveMax(card) {
      var effective = card.dataset.effectiveMaxQuantity;
      if (effective !== undefined && effective !== '') {
        var parsedEffective = parseInt(effective, 10);
        if (!isNaN(parsedEffective)) return parsedEffective;
      }

      var max = parseInt(card.dataset.maxQuantity, 10);
      return isNaN(max) ? 9999 : max;
    }

    function updateProductCard(card) {
      var qtyValueEl = card.querySelector('[data-shop-look-qty-value]');
      var badgeEl = card.querySelector('[data-shop-look-badge]');
      var mediaEl = card.querySelector('[data-shop-look-media]');
      var visualEl = card.querySelector('[data-shop-look-visual]');
      var minusBtn = card.querySelector('[data-shop-look-qty-minus]');
      var plusBtn = card.querySelector('[data-shop-look-qty-plus]');
      var qty = parseInt(qtyValueEl ? qtyValueEl.textContent : '0', 10) || 0;
      var available = card.dataset.available !== 'false';
      var maxQty = getEffectiveMax(card);
      var isSelected = qty > 0;
      var canIncrease = available && qty < maxQty;

      if (qtyValueEl) qtyValueEl.textContent = String(qty);

      if (badgeEl) {
        badgeEl.textContent = String(qty);
        badgeEl.hidden = !isSelected;
      }

      if (mediaEl) mediaEl.classList.toggle('is-selected', isSelected);
      if (visualEl) visualEl.classList.toggle('is-selected', isSelected);
      card.classList.toggle('is-selected', isSelected);

      if (minusBtn) minusBtn.disabled = qty <= 0;
      if (plusBtn) plusBtn.disabled = !canIncrease;
      card.classList.toggle('is-max-qty', qty >= maxQty && maxQty > 0);
      card.classList.toggle('is-stock-limited', maxQty === 0 && available);
    }

    function updateAddAllState() {
      var addAllBtn = drawer.querySelector('[data-shop-look-add-all]');
      if (!addAllBtn) return;

      var selectedCount = 0;
      drawer.querySelectorAll('[data-shop-look-product]').forEach(function (card) {
        var qty = parseInt(card.querySelector('[data-shop-look-qty-value]')?.textContent || '0', 10) || 0;
        if (qty > 0) selectedCount += 1;
      });

      renderAddAllButton(
        addAllBtn,
        addAllBtn.querySelector('[data-shop-look-add-all-text]'),
        addAllBtn.dataset.shopLookAddAllLabel || addAllBtn.textContent.trim(),
        addAllBtn.dataset.shopLookAddAllLoadingLabel || 'Agregando...',
        selectedCount
      );
    }

    function resetQuantities() {
      drawer.querySelectorAll('[data-shop-look-product]').forEach(function (card) {
        var qtyValueEl = card.querySelector('[data-shop-look-qty-value]');
        if (qtyValueEl) qtyValueEl.textContent = String(getDefaultQty(card));
        delete card.dataset.effectiveMaxQuantity;
        updateProductCard(card);
      });
    }

    function refreshInventoryFromCart() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          drawer.querySelectorAll('[data-shop-look-product]').forEach(function (card) {
            var variantId = parseInt(card.dataset.variantId, 10);
            var baseMax = parseInt(card.dataset.maxQuantity, 10);
            if (isNaN(baseMax)) baseMax = 9999;

            var inCart = 0;
            if (cart && cart.items) {
              cart.items.forEach(function (item) {
                if (item.variant_id === variantId) inCart += item.quantity;
              });
            }

            var managed = card.dataset.inventoryManaged === 'true';
            var effectiveMax = managed ? Math.max(0, baseMax - inCart) : baseMax;
            card.dataset.effectiveMaxQuantity = String(effectiveMax);

            var qtyValueEl = card.querySelector('[data-shop-look-qty-value]');
            var qty = parseInt(qtyValueEl ? qtyValueEl.textContent : '0', 10) || 0;
            if (qty > effectiveMax && qtyValueEl) {
              qtyValueEl.textContent = String(effectiveMax);
            }

            updateProductCard(card);
          });

          updateAddAllState();
        })
        .catch(function () {});
    }

    function syncDetailAddButton() {
      if (!detailAddBtn || !activeDetailCard) return;

      var available = activeDetailCard.dataset.available !== 'false';
      var maxQty = getEffectiveMax(activeDetailCard);
      var qtyValueEl = activeDetailCard.querySelector('[data-shop-look-qty-value]');
      var qty = parseInt(qtyValueEl ? qtyValueEl.textContent : '0', 10) || 0;
      var soldOut = !available || maxQty === 0;

      detailAddBtn.disabled = soldOut || qty >= maxQty;
      detailAddBtn.querySelector('.enova-pdp__btn-label').textContent = soldOut ? 'Agotado' : 'Agregar';
    }

    function initDetailGallery(container) {
      var gallery = container.querySelector('[data-build-set-detail-gallery]');
      if (!gallery) return;

      var track = gallery.querySelector('[data-build-set-detail-gallery-track]');
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-build-set-detail-gallery-slide]'));
      var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-build-set-detail-gallery-dot]'));
      var prevBtn = gallery.querySelector('[data-build-set-detail-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-build-set-detail-gallery-next]');
      if (!track || slides.length < 2) return;

      var currentIndex = 0;

      function goToSlide(index) {
        index = Math.max(0, Math.min(slides.length - 1, index));
        slides[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }

      function setActive(index) {
        currentIndex = index;

        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });

        if (prevBtn) prevBtn.disabled = index === 0;
        if (nextBtn) nextBtn.disabled = index === slides.length - 1;
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          goToSlide(index);
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goToSlide(currentIndex - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goToSlide(currentIndex + 1);
        });
      }

      setActive(0);

      if (typeof IntersectionObserver !== 'function') return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.6) return;
          var index = slides.indexOf(entry.target);
          if (index !== -1) setActive(index);
        });
      }, { root: track, threshold: [0.6] });

      slides.forEach(function (slide) {
        observer.observe(slide);
      });
    }

    function openShopLookDetail(card) {
      var template = card.querySelector('[data-shop-look-detail-template]');
      if (!template || !detailContentEl || !detailDrawer) return;

      activeDetailCard = card;
      detailContentEl.innerHTML = '';
      detailContentEl.appendChild(template.content.cloneNode(true));
      initDetailGallery(detailContentEl);
      syncDetailAddButton();
      openEnovaDrawer(detailDrawer);
    }

    trigger.addEventListener('click', function (event) {
      event.stopPropagation();
      openEnovaDrawer(drawer);
      refreshInventoryFromCart();
    });

    function getCartAddUrl() {
      var rootUrl = (window.theme && window.theme.routes && window.theme.routes.root)
        || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        || '/';
      return rootUrl.replace(/\/?$/, '/') + 'cart/add.js';
    }

    drawer.querySelectorAll('[data-shop-look-product]').forEach(function (card) {
      var minusBtn = card.querySelector('[data-shop-look-qty-minus]');
      var plusBtn = card.querySelector('[data-shop-look-qty-plus]');
      var qtyValueEl = card.querySelector('[data-shop-look-qty-value]');

      if (plusBtn) {
        plusBtn.addEventListener('click', function (event) {
          event.stopPropagation();
          var qty = parseInt(qtyValueEl.textContent || '0', 10) || 0;
          var maxQty = getEffectiveMax(card);
          if (qty >= maxQty) return;
          qtyValueEl.textContent = String(qty + 1);
          updateProductCard(card);
          updateAddAllState();
        });
      }

      if (minusBtn) {
        minusBtn.addEventListener('click', function (event) {
          event.stopPropagation();
          var qty = parseInt(qtyValueEl.textContent || '0', 10) || 0;
          if (qty <= 0) return;
          qtyValueEl.textContent = String(qty - 1);
          updateProductCard(card);
          updateAddAllState();
        });
      }

      updateProductCard(card);

      var detailTrigger = card.querySelector('[data-shop-look-detail-trigger]');
      if (detailTrigger) {
        detailTrigger.addEventListener('click', function (event) {
          event.stopPropagation();
          openShopLookDetail(card);
        });
      }

      card.addEventListener('click', function (event) {
        if (event.target.closest('[data-shop-look-qty-minus], [data-shop-look-qty-plus], [data-shop-look-detail-trigger]')) return;

        var qty = parseInt(qtyValueEl.textContent || '0', 10) || 0;
        var maxQty = getEffectiveMax(card);
        if (qty === 0 && plusBtn && !plusBtn.disabled && maxQty > 0) {
          qtyValueEl.textContent = '1';
          updateProductCard(card);
          updateAddAllState();
        }
      });
    });

    if (detailAddBtn) {
      detailAddBtn.addEventListener('click', function () {
        if (!activeDetailCard || detailAddBtn.disabled) return;

        var qtyValueEl = activeDetailCard.querySelector('[data-shop-look-qty-value]');
        var maxQty = getEffectiveMax(activeDetailCard);
        var qty = parseInt(qtyValueEl ? qtyValueEl.textContent : '0', 10) || 0;

        if (qty < maxQty) {
          qtyValueEl.textContent = String(qty + 1);
          updateProductCard(activeDetailCard);
          updateAddAllState();
        }

        closeEnovaDrawer(detailDrawer);
      });
    }

    function getMessageEl() {
      return drawer.querySelector('[data-shop-look-message]');
    }

    function showMessage(text, isSuccess) {
      var el = getMessageEl();
      if (!el) return;
      el.textContent = text;
      el.hidden = false;
      el.classList.toggle('enova-pdp__build-set-message--success', !!isSuccess);
    }

    function hideMessage() {
      var el = getMessageEl();
      if (!el) return;
      el.hidden = true;
    }

    function getCardTitle(card) {
      var titleEl = card.querySelector('.enova-pdp__build-set-product-title');
      return titleEl ? titleEl.textContent.trim() : 'un producto';
    }

    function markCardSoldOut(card) {
      var qtyValueEl = card.querySelector('[data-shop-look-qty-value]');
      if (qtyValueEl) qtyValueEl.textContent = '0';
      card.dataset.effectiveMaxQuantity = '0';
      card.dataset.defaultQty = '0';
      card.classList.add('enova-pdp__build-set-product--sold-out');
      updateProductCard(card);
    }

    /* Trazabilidad: marca de origen para reportes (linea + carrito completo). */
    var SHOP_LOOK_ORIGIN_PROPERTY = { _origen: 'shop-the-look' };
    var SHOP_LOOK_CART_ATTRIBUTE = { 'Incluye Shop the look': 'true' };

    function markCartAsShopLookOrigin() {
      var rootUrl = (window.theme && window.theme.routes && window.theme.routes.root)
        || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        || '/';
      fetch(rootUrl.replace(/\/?$/, '/') + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: SHOP_LOOK_CART_ATTRIBUTE }),
      }).catch(function () {});
    }

    function addSingleItem(variantId, quantity) {
      return fetch(getCartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity, properties: SHOP_LOOK_ORIGIN_PROPERTY }] }),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok && !data.status, data: data };
          });
        })
        .catch(function (err) {
          return { ok: false, data: err };
        });
    }

    function addItemsSequentially(entries) {
      var succeeded = [];
      var failed = [];

      function next(i) {
        if (i >= entries.length) {
          return Promise.resolve({ succeeded: succeeded, failed: failed });
        }
        var entry = entries[i];
        return addSingleItem(entry.variantId, entry.quantity).then(function (result) {
          if (result.ok) {
            succeeded.push(entry);
          } else {
            failed.push(entry);
            markCardSoldOut(entry.card);
          }
          return next(i + 1);
        });
      }

      return next(0);
    }

    var addAllBtn = drawer.querySelector('[data-shop-look-add-all]');
    if (addAllBtn) {
      addAllBtn.addEventListener('click', function () {
        var items = [];
        var entries = [];

        drawer.querySelectorAll('[data-shop-look-product]').forEach(function (card) {
          var qtyValueEl = card.querySelector('[data-shop-look-qty-value]');
          var qty = parseInt(qtyValueEl ? qtyValueEl.textContent : '0', 10) || 0;
          var variantId = parseInt(card.dataset.variantId, 10);
          var maxQty = getEffectiveMax(card);

          if (qty > maxQty) {
            qty = maxQty;
            if (qtyValueEl) qtyValueEl.textContent = String(qty);
            updateProductCard(card);
          }

          if (qty > 0 && variantId) {
            items.push({ id: variantId, quantity: qty, properties: SHOP_LOOK_ORIGIN_PROPERTY });
            entries.push({ card: card, variantId: variantId, quantity: qty, title: getCardTitle(card) });
          }
        });

        if (!items.length || addAllBtn.dataset.loading === 'true') return;

        hideMessage();
        addAllBtn.dataset.loading = 'true';
        updateAddAllState();

        fetch(getCartAddUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify({ items: items }),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            if (data && data.status) {
              throw data;
            }

            resetQuantities();
            updateAddAllState();

            closeEnovaDrawer(drawer);
            refreshThemeCartAfterAdd();
            markCartAsShopLookOrigin();
          })
          .catch(function () {
            return addItemsSequentially(entries).then(function (result) {
              result.succeeded.forEach(function (entry) {
                var qtyValueEl = entry.card.querySelector('[data-shop-look-qty-value]');
                if (qtyValueEl) qtyValueEl.textContent = String(getDefaultQty(entry.card));
                updateProductCard(entry.card);
              });

              if (result.succeeded.length) {
                refreshThemeCartAfterAdd();
                markCartAsShopLookOrigin();
              }

              if (result.failed.length && result.succeeded.length) {
                var failedNames = result.failed.map(function (e) { return e.title; }).join(', ');
                showMessage(
                  'Se agregaron ' + result.succeeded.length + ' producto(s). "' + failedNames + '" ya no tiene stock disponible y se quitó de tu selección.',
                  false
                );
              } else if (result.failed.length) {
                var allFailedNames = result.failed.map(function (e) { return e.title; }).join(', ');
                showMessage('"' + allFailedNames + '" ya no tiene stock disponible. Actualiza tu selección e intenta de nuevo.', false);
              } else {
                closeEnovaDrawer(drawer);
              }

              updateAddAllState();
            });
          })
          .finally(function () {
            delete addAllBtn.dataset.loading;
            updateAddAllState();
          });
      });
    }

    updateAddAllState();
  }

  // Registro de módulos del PDP: cada módulo recibe el root [data-enova-pdp] y se
  // inicializa en DOMContentLoaded y en shopify:section:load. Un módulo que se registra
  // tarde se ejecuta en los roots ya inicializados.
  var modules = [];
  var initializedRoots = [];

  function runModule(mod, section) {
    try {
      mod(section);
    } catch (error) {
      console.error('[EnovaPDP] Error inicializando módulo', error);
    }
  }

  window.EnovaPDP = window.EnovaPDP || {};
  window.EnovaPDP.register = function (mod) {
    if (typeof mod !== 'function') return;
    modules.push(mod);
    initializedRoots.forEach(function (section) {
      if (document.contains(section)) runModule(mod, section);
    });
  };

  function initSection(section) {
    initPromoCountdowns(section);
    initStorePickup(section);
    initCartBar(section);
    initInfoDrawer(section);
    initBuildSet(section);
    initShopLook(section);
    initGallerySlider(section);

    modules.forEach(function (mod) {
      runModule(mod, section);
    });
    if (initializedRoots.indexOf(section) === -1) initializedRoots.push(section);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-enova-pdp]').forEach(initSection);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-enova-pdp]');
    if (section) initSection(section);
  });
})();


/* ==== PDP v2 · layout ==== */
/*
  1) Galería editorial (desktop): mantiene la clase enova-pdp__slide--wide en el último slide
     no-hero cuando el resto es impar (se recalcula al cambiar data-active-media, p. ej. por
     variante) y limpia el estado "media--hiding" del fader, que en desktop no tiene transición.
  2) Columna de medios sticky (desktop): solo cuando la galería cabe en el viewport y el
     contenido de la derecha es más alto que ella. En cualquier otro caso queda estática.
*/
(function () {
  'use strict';

  var DESKTOP_QUERY = '(min-width: 750px)';
  var WIDE_CLASS = 'enova-pdp__slide--wide';
  var STICKY_CLASS = 'enova-pdp__media-column--sticky';
  var STICKY_GAP = 16; // aire bajo el header y sobre el borde inferior del viewport

  function isDesktop() {
    return window.matchMedia ? window.matchMedia(DESKTOP_QUERY).matches : window.innerWidth >= 750;
  }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  /* ---------------- 1) Galería editorial ---------------- */

  function initEditorialGallery(root) {
    var productImages = root.querySelector('product-images.product__images--editorial');
    if (!productImages) return;

    function getSlides() {
      var list = productImages.querySelector('[data-product-media-list]');
      if (!list) return [];
      return toArray(list.children).filter(function (el) {
        return el.classList && el.classList.contains('product__slide') && el.hasAttribute('data-media-id');
      });
    }

    function update() {
      var slides = getSlides();
      var rest = slides.filter(function (slide) {
        return !slide.classList.contains('media--active');
      });
      var wide = rest.length % 2 === 1 ? rest[rest.length - 1] : null;

      slides.forEach(function (slide) {
        slide.classList.toggle(WIDE_CLASS, slide === wide);

        // En desktop editorial no hay transición, así que el tema nunca recibe el transitionend
        // que pasa "media--hiding" a "media--hidden": se completa aquí.
        if (isDesktop() && slide.classList.contains('media--hiding') && !slide.classList.contains('media--active')) {
          slide.classList.remove('media--hiding');
          slide.classList.add('media--hidden');
        }
      });
    }

    update();

    if (window.MutationObserver) {
      var observer = new MutationObserver(function () {
        update();
      });
      observer.observe(productImages, { attributes: true, attributeFilter: ['data-active-media'] });
      // setActiveMedia cambia primero el atributo y luego las clases: se vuelve a mirar las clases.
      getSlides().forEach(function (slide) {
        observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
      });
    }
  }

  /* ---------------- 2) Sticky de la columna de medios ---------------- */

  var stickyRoots = [];
  var windowListenersBound = false;
  var rafId = null;

  function readPx(value) {
    var n = parseFloat(value);
    return isNaN(n) ? 0 : n;
  }

  // Alto ocupado por el header sticky: el mayor entre la variable del tema y el borde inferior real
  // del header (la variable no incluye la barra de anuncios que queda encima).
  function stickyTop() {
    var header = 0;
    try {
      header = readPx(getComputedStyle(document.body).getPropertyValue('--header-sticky-height'));
      if (header > 0) {
        var headerEl = document.querySelector('[data-header-height]');
        var bottom = headerEl ? headerEl.getBoundingClientRect().bottom : 0;
        if (bottom > header && bottom < window.innerHeight / 3) header = bottom;
      }
    } catch (e) {
      header = 0;
    }
    return Math.round(header) + STICKY_GAP;
  }

  function updateSticky(root) {
    var column = root.querySelector('.enova-pdp__media-column');
    var form = root.querySelector('.product__page [data-form-wrapper]');
    if (!column || !form) return;

    var shouldStick = false;

    if (isDesktop()) {
      var mediaHeight = column.offsetHeight;
      var formHeight = form.offsetHeight;
      var top = stickyTop();
      var fitsViewport = mediaHeight > 0 && mediaHeight + top + STICKY_GAP <= window.innerHeight;
      shouldStick = fitsViewport && formHeight > mediaHeight + STICKY_GAP;
      if (shouldStick) column.style.setProperty('--enova-pdp-media-sticky-top', top + 'px');
    }

    column.classList.toggle(STICKY_CLASS, shouldStick);
    if (!shouldStick) column.style.removeProperty('--enova-pdp-media-sticky-top');
  }

  function updateAllSticky() {
    rafId = null;
    stickyRoots = stickyRoots.filter(function (root) {
      return document.contains(root);
    });
    stickyRoots.forEach(updateSticky);
  }

  function scheduleSticky() {
    if (rafId) return;
    rafId = window.requestAnimationFrame ? window.requestAnimationFrame(updateAllSticky) : setTimeout(updateAllSticky, 16);
  }

  function initMediaSticky(root) {
    var column = root.querySelector('.enova-pdp__media-column');
    var form = root.querySelector('.product__page [data-form-wrapper]');
    if (!column || !form) return;

    if (stickyRoots.indexOf(root) === -1) stickyRoots.push(root);

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(scheduleSticky);
      ro.observe(column);
      ro.observe(form);
    }

    if (!windowListenersBound) {
      windowListenersBound = true;
      window.addEventListener('resize', scheduleSticky);
      window.addEventListener('load', scheduleSticky);
      document.addEventListener('theme:resize', scheduleSticky);
    }

    scheduleSticky();
  }

  function init(root) {
    if (!root || root.dataset.enovaLayoutInit) return;
    root.dataset.enovaLayoutInit = '1';

    initEditorialGallery(root);
    initMediaSticky(root);
  }

  if (window.EnovaPDP && typeof window.EnovaPDP.register === 'function') {
    window.EnovaPDP.register(init);
  } else {
    // Respaldo si enova-product.js no cargó: se inicializa por cuenta propia.
    var boot = function () {
      toArray(document.querySelectorAll('[data-enova-pdp]')).forEach(init);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target && event.target.querySelector && event.target.querySelector('[data-enova-pdp]');
      if (section) init(section);
    });
  }
})();


/* ==== PDP v2 · header ==== */
/*
  Fila de precio + SKU.
  El ProductForm del tema (theme.dev.js) ya reescribe precios, pill y SKU al cambiar de variante
  y luego dispara theme:variant:change. Este módulo re-sincroniza sólo el ESTADO (clases/visibilidad,
  % del pill, texto y visibilidad del SKU) desde event.detail.variant, para que la fila quede
  coherente aunque el evento lo dispare otro componente (p. ej. el selector de variantes)
  o una variante no tenga SKU. No toca el texto de los montos (lo formatea el tema).
*/
(function () {
  'use strict';

  function toggleClass(el, className, force) {
    if (!el) return;
    if (force) {
      el.classList.add(className);
    } else {
      el.classList.remove(className);
    }
  }

  function skuLabel() {
    return (window.theme && window.theme.strings && window.theme.strings.sku) || 'SKU';
  }

  function syncPrice(root, variant) {
    var wrapper = root.querySelector('[data-enova-pdp-price]');
    if (!wrapper) return;

    var price = Number(variant.price);
    var compare = Number(variant.compare_at_price);
    var onSale = compare > price;

    toggleClass(wrapper.querySelector('[data-compare-price]'), 'hidden', !onSale);
    toggleClass(wrapper.querySelector('[data-compare-text]'), 'hidden', !onSale);
    toggleClass(wrapper.querySelector('[data-product-price]'), 'product__price--sale', onSale);

    var pill = wrapper.querySelector('[data-price-off]');
    if (pill) {
      if (onSale) {
        var amount = pill.querySelector('[data-price-off-amount]');
        // Misma fórmula que el tema (Math.floor) y que el Liquid del snippet
        if (amount) amount.textContent = Math.floor(((compare - price) / compare) * 100) + '%';
        pill.classList.remove('hidden');
      } else {
        pill.classList.add('hidden');
      }
    }
  }

  function syncSku(root, variant) {
    var sku = root.querySelector('[data-variant-sku]');
    if (!sku) return;

    var value = variant.sku ? String(variant.sku).trim() : '';
    if (value) {
      sku.textContent = skuLabel() + ': ' + value;
      sku.classList.remove('hidden');
    } else {
      sku.classList.add('hidden');
    }
  }

  function init(root) {
    if (!root || root.dataset.enovaPdpHeaderInit) return;
    root.dataset.enovaPdpHeaderInit = '1';

    root.addEventListener('theme:variant:change', function (event) {
      var variant = event && event.detail && event.detail.variant;
      if (!variant) return;

      try {
        syncPrice(root, variant);
        syncSku(root, variant);
      } catch (error) {
        if (window.console) console.error('[EnovaPDP header] Error sincronizando variante', error);
      }
    });
  }

  if (window.EnovaPDP && typeof window.EnovaPDP.register === 'function') {
    window.EnovaPDP.register(init);
  }
})();


/* ==== PDP v2 · buy ==== */
/*
   Selector de talla (chips) + sincronía de la barra fija de compra.

   El cambio de variante lo resuelve el motor del tema (theme.dev.js → ProductForm /
   ProductFormReader): los radios [name^="options"] del snippet enova-pdp-variant-picker
   actualizan el input [name="id"][form], precio, SKU, botón, URL (?variant=) y disparan
   theme:variant:change. Este módulo solo:
   - recalcula qué valores están agotados / no existen para la selección actual
     (deshabilita el radio, tacha el chip y actualiza el texto accesible);
   - replica el estado disponible/agotado en el botón de la barra fija, que el tema no
     conoce porque no es [data-add-to-cart]. */
(function () {
  'use strict';

  function readProductJSON(root) {
    var el = root.querySelector('[data-product-json]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  function findVariant(product, selections) {
    if (!product || !product.variants) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      var match = true;
      for (var j = 0; j < selections.length; j++) {
        if (variant.options[j] !== selections[j]) {
          match = false;
          break;
        }
      }
      if (match) return variant;
    }
    return null;
  }

  function initBuy(root) {
    if (!root || root.dataset.enovaBuyInit) return;
    root.dataset.enovaBuyInit = '1';

    var product = readProductJSON(root);
    var picker = root.querySelector('[data-enova-pdp-variant-picker]');
    var cartBarBtn = root.querySelector('[data-enova-pdp-cart-bar] [data-add-to-cart-bar]');
    var groups = picker ? Array.prototype.slice.call(picker.querySelectorAll('[data-option-position]')) : [];
    var singleOption = groups.length === 1;

    function groupPosition(group) {
      return parseInt(group.getAttribute('data-option-position'), 10) - 1;
    }

    function checkedSelections() {
      var selections = [];
      groups.forEach(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        selections[groupPosition(group)] = checked ? checked.value : null;
      });
      return selections;
    }

    function refreshPicker(variant) {
      if (!groups.length || !product) return;

      var selections = variant && variant.options ? variant.options.slice() : checkedSelections();

      groups.forEach(function (group) {
        var position = groupPosition(group);
        var inputs = group.querySelectorAll('input[type="radio"]');

        Array.prototype.forEach.call(inputs, function (input) {
          var candidate = selections.slice();
          candidate[position] = input.value;

          var found = findVariant(product, candidate);
          var available = !!(found && found.available);
          var chip = input.closest('[data-enova-pdp-variant-chip]');
          var soldOutText = chip ? chip.querySelector('[data-enova-pdp-variant-soldout-text]') : null;

          if (chip) {
            chip.classList.toggle('is-sold-out', !available);
            chip.classList.toggle('is-unavailable', !found);
          }

          // Solo con una opción se bloquea el valor agotado (nunca el elegido: el formulario
          // perdería la selección). Con varias opciones queda tachado pero elegible.
          input.disabled = singleOption && !available && !input.checked;

          if (soldOutText) soldOutText.hidden = available;
        });
      });
    }

    function syncCartBar(variant) {
      if (!cartBarBtn) return;
      var available = !!(variant && variant.available);
      cartBarBtn.disabled = !available;

      var off = root.querySelector('[data-enova-pdp-cart-bar-off]');
      if (off && variant) {
        var compare = variant.compare_at_price || 0;
        var onSale = compare > variant.price;
        off.classList.toggle('hidden', !onSale);
        if (onSale) off.textContent = '-' + Math.floor(((compare - variant.price) / compare) * 100) + '% OFF';
      }

      var label = cartBarBtn.querySelector('[data-enova-pdp-cart-bar-label]');
      if (label) label.textContent = available ? cartBarBtn.dataset.labelAdd : cartBarBtn.dataset.labelSoldout;

      // Miniatura de la variante (si tiene imagen propia)
      var img = root.querySelector('[data-enova-pdp-cart-bar-img]');
      var src = variant && variant.featured_image && variant.featured_image.src;
      if (img && src) {
        var url = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=160';
        if (img.getAttribute('src') !== url) {
          img.removeAttribute('srcset');
          img.src = url;
        }
      }
    }

    root.addEventListener('theme:variant:change', function (event) {
      var variant = event.detail ? event.detail.variant : null;
      refreshPicker(variant);
      syncCartBar(variant);
    });

    // Estado inicial: el ProductForm del tema ya aplicó la variante marcada en el HTML
    // (incluida la de ?variant=) antes de que este módulo escuche el evento.
    var initialVariant = groups.length ? findVariant(product, checkedSelections()) : null;
    if (!initialVariant && product && product.variants) {
      var idInput = root.querySelector('[data-form-wrapper] input[name="id"][form]');
      var idValue = idInput ? String(idInput.value) : '';
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === idValue) {
          initialVariant = product.variants[i];
          break;
        }
      }
    }

    refreshPicker(initialVariant);
    if (initialVariant) syncCartBar(initialVariant);
  }

  if (window.EnovaPDP && typeof window.EnovaPDP.register === 'function') {
    window.EnovaPDP.register(initBuy);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-enova-pdp]'), initBuy);
    });
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target && event.target.querySelector ? event.target.querySelector('[data-enova-pdp]') : null;
      if (root) initBuy(root);
    });
  }
})();


/* ==== PDP v2 · readmore ==== */
(function () {
  'use strict';

  var SELECTOR = '[data-enova-pdp-readmore]';
  var REFRESH_EVENT = 'enova:readmore:refresh';
  var ANIMATION_MS = 360;

  var globalListenersBound = false;
  var resizeTimer = null;
  var resizeObserver = null;

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function getParts(wrapper) {
    return {
      body: wrapper.querySelector('.enova-pdp__readmore-body'),
      toggle: wrapper.querySelector('.enova-pdp__readmore-toggle'),
      label: wrapper.querySelector('[data-enova-pdp-readmore-label]')
    };
  }

  function isRendered(el) {
    return !!(el && el.getClientRects().length);
  }

  // Altura máxima en px del estado colapsado (N líneas).
  function collapsedLimit(wrapper, body) {
    var style = window.getComputedStyle(body);
    var lines = parseFloat(window.getComputedStyle(wrapper).getPropertyValue('--enova-readmore-lines'));
    if (!lines || lines < 1) lines = 3;
    var lineHeight = parseFloat(style.lineHeight);
    if (!lineHeight || isNaN(lineHeight)) lineHeight = (parseFloat(style.fontSize) || 13) * 1.55;
    return lines * lineHeight;
  }

  function setLabel(wrapper, expanded) {
    var parts = getParts(wrapper);
    if (!parts.toggle) return;
    var text = expanded ? parts.toggle.getAttribute('data-less-text') : parts.toggle.getAttribute('data-more-text');
    if (parts.label && text) parts.label.textContent = text;
    parts.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function clearAnimation(wrapper) {
    var parts = getParts(wrapper);
    if (wrapper._enovaReadmoreTimer) {
      window.clearTimeout(wrapper._enovaReadmoreTimer);
      wrapper._enovaReadmoreTimer = null;
    }
    wrapper.classList.remove('is-animating');
    if (parts.body) parts.body.style.maxHeight = '';
  }

  // Mide si el contenido desborda las N líneas y muestra/oculta el botón.
  function measure(wrapper) {
    var parts = getParts(wrapper);
    if (!parts.body || !parts.toggle) return;
    // Dentro de un panel oculto (display: none) no se puede medir: se conserva el
    // estado y se vuelve a medir con ResizeObserver o con 'enova:readmore:refresh'.
    if (!isRendered(parts.body)) return;
    if (wrapper.classList.contains('is-animating')) return;

    var expanded = wrapper.classList.contains('is-expanded');
    var overflowing;
    if (expanded) {
      overflowing = parts.body.scrollHeight > collapsedLimit(wrapper, parts.body) + 1;
    } else {
      overflowing = parts.body.scrollHeight > parts.body.clientHeight + 1;
    }

    if (overflowing) {
      wrapper.classList.add('is-overflowing');
      parts.toggle.hidden = false;
    } else {
      wrapper.classList.remove('is-overflowing', 'is-expanded');
      parts.toggle.hidden = true;
      setLabel(wrapper, false);
    }
  }

  function measureWithin(scope) {
    if (!scope || !scope.querySelectorAll) return;
    if (scope.matches && scope.matches(SELECTOR)) measure(scope);
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), measure);
  }

  function measureAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-enova-pdp] ' + SELECTOR), measure);
  }

  function expand(wrapper) {
    var parts = getParts(wrapper);
    var body = parts.body;
    clearAnimation(wrapper);
    setLabel(wrapper, true);

    if (reducedMotion()) {
      wrapper.classList.add('is-expanded');
      return;
    }

    var start = body.clientHeight;
    body.style.maxHeight = start + 'px';
    wrapper.classList.add('is-expanded', 'is-animating');
    void body.offsetHeight; // fuerza reflow antes de animar
    body.style.maxHeight = body.scrollHeight + 'px';
    wrapper._enovaReadmoreTimer = window.setTimeout(function () {
      clearAnimation(wrapper);
    }, ANIMATION_MS);
  }

  function collapse(wrapper) {
    var parts = getParts(wrapper);
    var body = parts.body;
    clearAnimation(wrapper);
    setLabel(wrapper, false);

    if (reducedMotion()) {
      wrapper.classList.remove('is-expanded');
      return;
    }

    var target = collapsedLimit(wrapper, body);
    body.style.maxHeight = body.scrollHeight + 'px';
    wrapper.classList.add('is-animating');
    void body.offsetHeight;
    wrapper.classList.remove('is-expanded');
    body.style.maxHeight = target + 'px';
    wrapper._enovaReadmoreTimer = window.setTimeout(function () {
      clearAnimation(wrapper);
      measure(wrapper);
    }, ANIMATION_MS);
  }

  function setupWrapper(wrapper) {
    if (wrapper.dataset.enovaReadmoreInit) return;
    wrapper.dataset.enovaReadmoreInit = '1';

    var parts = getParts(wrapper);
    if (!parts.body || !parts.toggle) return;

    parts.toggle.addEventListener('click', function (event) {
      event.preventDefault();
      if (wrapper.classList.contains('is-expanded')) {
        collapse(wrapper);
      } else {
        expand(wrapper);
      }
    });

    if (resizeObserver) resizeObserver.observe(parts.body);

    // Si el contenido cambia estando recortado, el alto del body no cambia y el
    // ResizeObserver no avisa: se vuelve a medir ante cambios de contenido.
    if ('MutationObserver' in window) {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          measure(wrapper);
        });
      }).observe(parts.body, { childList: true, subtree: true, characterData: true });
    }

    measure(wrapper);
  }

  function bindGlobalListeners() {
    if (globalListenersBound) return;
    globalListenersBound = true;

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          var wrapper = entry.target.closest(SELECTOR);
          if (wrapper) measure(wrapper);
        });
      });
    }

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(measureAll, 150);
    });

    // Las fuentes web cambian el alto del texto sin cambiar el tamaño del body recortado.
    if (document.fonts) {
      if (document.fonts.ready) document.fonts.ready.then(measureAll).catch(function () {});
      if (typeof document.fonts.addEventListener === 'function') {
        document.fonts.addEventListener('loadingdone', function () {
          window.clearTimeout(resizeTimer);
          resizeTimer = window.setTimeout(measureAll, 50);
        });
      }
    }
    window.addEventListener('load', measureAll);
  }

  function initReadMore(root) {
    if (!root) return;
    bindGlobalListeners();

    if (!root.dataset.enovaReadmoreRoot) {
      root.dataset.enovaReadmoreRoot = '1';
      // Los paneles que pasan de ocultos a visibles (tabs) despachan este evento.
      root.addEventListener(REFRESH_EVENT, function (event) {
        var scope = event.target && event.target.nodeType === 1 ? event.target : root;
        Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), setupWrapper);
        if (scope.matches && scope.matches(SELECTOR)) setupWrapper(scope);
        measureWithin(scope);
      });
    }

    Array.prototype.forEach.call(root.querySelectorAll(SELECTOR), setupWrapper);
  }

  function register() {
    if (window.EnovaPDP && typeof window.EnovaPDP.register === 'function') {
      window.EnovaPDP.register(initReadMore);
      return true;
    }
    return false;
  }

  if (!register()) {
    // enova-product.js aún no cargó: reintentar al DOMContentLoaded.
    document.addEventListener('DOMContentLoaded', function () {
      if (!register()) {
        Array.prototype.forEach.call(document.querySelectorAll('[data-enova-pdp]'), initReadMore);
      }
    });
  }
})();


/* ==== PDP v2 · tabs ==== */
/* Pestañas informativas (bloque info_tabs): WAI-ARIA tabs con activación automática,
   tabindex itinerante, flechas izquierda/derecha (circular), Inicio/Fin y scroll
   horizontal de la fila en móvil. No usa los hooks de GlobalTabs del tema. */
(function () {
  'use strict';

  var CONTAINER = '[data-enova-pdp-info-tabs]';
  var LIST = '[data-enova-pdp-info-tablist]';
  var TAB = '[data-enova-pdp-info-tab]';
  var PANEL = '[data-enova-pdp-info-panel]';
  var REFRESH_EVENT = 'enova:readmore:refresh';
  var EDGE_MARGIN = 24;

  var documentListenersBound = false;
  var resizeTimer = null;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function getTabs(container) {
    return toArray(container.querySelectorAll(TAB));
  }

  function getPanel(container, tab) {
    var id = tab && tab.getAttribute('aria-controls');
    if (!id) return null;
    var panel = document.getElementById(id);
    return panel && container.contains(panel) ? panel : null;
  }

  function refreshPanel(panel) {
    if (!panel) return;
    var event;
    try {
      event = new CustomEvent(REFRESH_EVENT, { bubbles: true });
    } catch (error) {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(REFRESH_EVENT, true, false, null);
    }
    panel.dispatchEvent(event);
  }

  // Indicador de desborde de la fila (degradado en el extremo con más pestañas).
  function updateOverflow(list) {
    if (!list) return;
    var maxScroll = list.scrollWidth - list.clientWidth;
    var state = 'none';

    if (maxScroll > 1) {
      var atStart = list.scrollLeft <= 1;
      var atEnd = list.scrollLeft >= maxScroll - 1;
      if (atStart && !atEnd) state = 'end';
      else if (!atStart && atEnd) state = 'start';
      else if (!atStart && !atEnd) state = 'both';
    }

    if (list.getAttribute('data-overflow') !== state) list.setAttribute('data-overflow', state);
  }

  // Desplaza solo la fila (nunca la página) para que la pestaña quede visible.
  function scrollTabIntoView(list, tab, smooth) {
    if (!list || !tab || list.scrollWidth <= list.clientWidth + 1) return;

    var listRect = list.getBoundingClientRect();
    var tabRect = tab.getBoundingClientRect();
    var left = tabRect.left - listRect.left + list.scrollLeft;
    var right = left + tabRect.width;
    var viewStart = list.scrollLeft;
    var viewEnd = viewStart + list.clientWidth;
    var target = null;

    if (left < viewStart + EDGE_MARGIN) {
      target = left - EDGE_MARGIN;
    } else if (right > viewEnd - EDGE_MARGIN) {
      target = right - list.clientWidth + EDGE_MARGIN;
    }

    if (target === null) return;
    target = Math.max(0, Math.min(target, list.scrollWidth - list.clientWidth));

    if (typeof list.scrollTo === 'function') {
      try {
        list.scrollTo({ left: target, behavior: smooth && !prefersReducedMotion() ? 'smooth' : 'auto' });
        return;
      } catch (error) {
        // Navegadores sin ScrollToOptions: se usa scrollLeft.
      }
    }
    list.scrollLeft = target;
  }

  function activate(container, tab, options) {
    options = options || {};
    var tabs = getTabs(container);
    if (!tab || tabs.indexOf(tab) === -1) return;

    var shownPanel = null;

    tabs.forEach(function (item) {
      var selected = item === tab;
      var panel = getPanel(container, item);

      item.setAttribute('aria-selected', selected ? 'true' : 'false');
      item.setAttribute('tabindex', selected ? '0' : '-1');
      item.classList.toggle('is-active', selected);

      if (!panel) return;
      if (selected) {
        if (panel.hidden) shownPanel = panel;
        panel.hidden = false;
        panel.classList.add('is-active');
      } else {
        panel.hidden = true;
        panel.classList.remove('is-active');
      }
    });

    if (options.focus && document.activeElement !== tab) {
      try {
        tab.focus({ preventScroll: true });
      } catch (error) {
        tab.focus();
      }
    }

    var list = container.querySelector(LIST);
    scrollTabIntoView(list, tab, options.smooth !== false);
    updateOverflow(list);

    // El "Leer más" del panel recién visible necesita medirse (oculto mide 0).
    if (shownPanel || options.refresh) refreshPanel(getPanel(container, tab));
  }

  function onKeydown(container, event) {
    var tab = event.target && event.target.closest ? event.target.closest(TAB) : null;
    if (!tab || !container.contains(tab)) return;

    var tabs = getTabs(container);
    var index = tabs.indexOf(tab);
    if (index === -1 || tabs.length < 2) return;

    var next = null;
    switch (event.key) {
      case 'ArrowRight':
      case 'Right':
        next = tabs[(index + 1) % tabs.length];
        break;
      case 'ArrowLeft':
      case 'Left':
        next = tabs[(index - 1 + tabs.length) % tabs.length];
        break;
      case 'Home':
        next = tabs[0];
        break;
      case 'End':
        next = tabs[tabs.length - 1];
        break;
      default:
        return;
    }

    event.preventDefault();
    activate(container, next, { focus: true });
  }

  function setupContainer(container) {
    if (!container || container.dataset.enovaInfoTabsReady) return;
    container.dataset.enovaInfoTabsReady = '1';

    var tabs = getTabs(container);
    if (!tabs.length) return;

    var list = container.querySelector(LIST);

    container.addEventListener('click', function (event) {
      var tab = event.target && event.target.closest ? event.target.closest(TAB) : null;
      if (!tab || !container.contains(tab)) return;
      event.preventDefault();
      activate(container, tab, { focus: false });
    });

    container.addEventListener('keydown', function (event) {
      onKeydown(container, event);
    });

    if (list) {
      list.addEventListener('scroll', function () {
        updateOverflow(list);
      }, { passive: true });
    }

    // Estado inicial coherente (la primera pestaña con aria-selected="true" o la primera).
    var current = null;
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].getAttribute('aria-selected') === 'true') {
        current = tabs[i];
        break;
      }
    }
    activate(container, current || tabs[0], { focus: false, smooth: false });
  }

  function refreshAllOverflow() {
    toArray(document.querySelectorAll('[data-enova-pdp] ' + LIST)).forEach(updateOverflow);
  }

  function bindDocumentListeners() {
    if (documentListenersBound) return;
    documentListenersBound = true;

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(refreshAllOverflow, 150);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refreshAllOverflow).catch(function () {});
    }

    // Editor de temas: al seleccionar el bloque se vuelve a medir el panel activo;
    // si el elemento seleccionado está dentro de un panel oculto, se activa su pestaña.
    document.addEventListener('shopify:block:select', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var container = target.closest(CONTAINER) || (target.querySelector && target.querySelector(CONTAINER));
      if (!container) return;
      setupContainer(container);

      var panel = target.closest(PANEL);
      var tab = null;
      if (panel && container.contains(panel)) {
        tab = document.getElementById(panel.getAttribute('aria-labelledby'));
      }
      if (!tab) tab = container.querySelector(TAB + '[aria-selected="true"]') || container.querySelector(TAB);
      if (tab) activate(container, tab, { focus: false, smooth: false, refresh: true });
    });
  }

  function initInfoTabs(root) {
    if (!root || root.dataset.enovaInfoTabsInit) return;
    root.dataset.enovaInfoTabsInit = '1';

    bindDocumentListeners();
    toArray(root.querySelectorAll(CONTAINER)).forEach(setupContainer);
  }

  if (window.EnovaPDP && typeof window.EnovaPDP.register === 'function') {
    window.EnovaPDP.register(initInfoTabs);
  } else {
    // Respaldo si enova-product.js no cargó: misma inicialización por sección.
    var initAll = function () {
      toArray(document.querySelectorAll('[data-enova-pdp]')).forEach(initInfoTabs);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target && event.target.querySelector ? event.target.querySelector('[data-enova-pdp]') : null;
      if (section) initInfoTabs(section);
    });
  }
})();


/* ==== PDP v2 · look ==== */
/*
 * "Completa tu look" ([data-enova-pdp-complete-look]):
 * - Si el bloque trae data-look-url (sin complementarios), carga las filas desde
 *   /recommendations/products?section_id=api-enova-complete-look (intent=related) y lo muestra solo si vuelve algo.
 * - "Agregar +" agrega en línea (POST /cart/add.js) sin abrir el minicart, igual que el popup
 *   Shop the look del home (sections/section-shop-the-look.liquid): selector de talla para multivariante,
 *   estado "Agregado a la bolsa", refresco del carrito cortando el siguiente theme:product:added y
 *   reseteo de la fila cuando su variante sale del carrito (theme:cart:change).
 */
(function () {
  'use strict';

  var BLOCK_SELECTOR = '[data-enova-pdp-complete-look]';
  var documentBound = false;

  function cartUrl() {
    return (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
  }

  function cartAddUrl() {
    return ((window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add') + '.js';
  }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  // Tras cada getCart() el tema dispara theme:product:added, que abre el minicart. Para agregar sin
  // abrirlo, cortamos ese evento una vez (la captura en window corre antes que los listeners de document).
  // Devuelve una función para cancelar el corte si el refresco no llega a dispararlo.
  function suppressNextProductAdded() {
    var timeout;
    function release() {
      window.removeEventListener('theme:product:added', stop, true);
      clearTimeout(timeout);
    }
    function stop(event) {
      event.stopImmediatePropagation();
      release();
    }
    window.addEventListener('theme:product:added', stop, true);
    timeout = setTimeout(release, 5000);
    return release;
  }

  function dispatchCartCount() {
    return fetch(cartUrl() + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cartCount: cart.item_count } }));
      })
      .catch(function () { /* noop */ });
  }

  // Refresca el minicart y el contador de la bolsa sin abrir el drawer. No usa _pendingAddToCart,
  // así que tampoco aparece el aviso de monto mínimo del tema.
  function refreshCart() {
    var cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.getCart === 'function') {
      var release = suppressNextProductAdded();
      try {
        cartItems.getCart();
      } catch (error) {
        release();
        dispatchCartCount();
      }
      return;
    }
    dispatchCartCount();
  }

  function resetHolder(holder) {
    delete holder.dataset.addedVariant;
    var added = holder.querySelector('[data-stl-added]');
    var error = holder.querySelector('[data-stl-error]');
    if (added) added.hidden = true;
    if (error) error.hidden = true;
    toArray(holder.querySelectorAll('[data-stl-variant-picker]')).forEach(function (picker) {
      picker.hidden = true;
    });
    toArray(holder.querySelectorAll('.shop-the-look-modal__product-btn')).forEach(function (button) {
      button.hidden = false;
      if (button.hasAttribute('data-stl-variant-toggle')) button.setAttribute('aria-expanded', 'false');
    });
  }

  // Si lo agregado se elimina del carrito (p. ej. desde el minicart), la fila vuelve a "Agregar +".
  function syncAddedStates() {
    var holders = toArray(document.querySelectorAll(BLOCK_SELECTOR + ' [data-stl-product][data-added-variant]'));
    if (!holders.length) return;

    fetch(cartUrl() + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var variantIds = (cart.items || []).map(function (item) { return String(item.variant_id); });
        holders.forEach(function (holder) {
          if (variantIds.indexOf(holder.dataset.addedVariant) === -1) resetHolder(holder);
        });
      })
      .catch(function () { /* noop */ });
  }

  function bindDocument() {
    if (documentBound) return;
    documentBound = true;
    document.addEventListener('theme:cart:change', syncAddedStates);
  }

  function addVariant(holder, addButton) {
    var added = holder.querySelector('[data-stl-added]');
    var error = holder.querySelector('[data-stl-error]');
    if (holder.classList.contains('is-loading')) return;

    holder.classList.add('is-loading');
    holder.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(addButton.dataset.variantId), quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function () {
        var hadFocus = holder.contains(document.activeElement);
        holder.dataset.addedVariant = addButton.dataset.variantId;
        toArray(holder.querySelectorAll('.shop-the-look-modal__product-btn, [data-stl-variant-picker]')).forEach(function (el) {
          el.hidden = true;
        });
        if (added) {
          var meta = added.querySelector('[data-stl-added-meta]');
          if (meta) meta.textContent = addButton.dataset.variantTitle || '';
          added.hidden = false;
          // El botón enfocado se oculta: el foco pasa al mensaje para no perderse
          if (hadFocus) {
            added.setAttribute('tabindex', '-1');
            added.focus({ preventScroll: true });
          }
        }
        refreshCart();
      })
      .catch(function (data) {
        if (!error) return;
        error.textContent = (data && (data.description || data.message)) || 'No se pudo agregar. Inténtalo de nuevo.';
        error.hidden = false;
      })
      .then(function () {
        holder.classList.remove('is-loading');
        holder.removeAttribute('aria-busy');
      });
  }

  function onBlockClick(event) {
    var toggle = event.target.closest('[data-stl-variant-toggle]');
    if (toggle && this.contains(toggle)) {
      var picker = toggle.parentElement.querySelector('[data-stl-variant-picker]');
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'true');
      if (picker) {
        picker.hidden = false;
        var firstOption = picker.querySelector('[data-stl-add]:not([disabled])');
        if (firstOption) firstOption.focus();
      }
      return;
    }

    var addButton = event.target.closest('[data-stl-add]');
    if (!addButton || addButton.disabled || !this.contains(addButton)) return;

    var holder = addButton.closest('[data-stl-product]');
    if (holder) addVariant(holder, addButton);
  }

  // Ajusta el texto del botón de las filas que vienen de la API al del bloque.
  function applyButtonText(scope, text) {
    if (!text) return;
    toArray(scope.querySelectorAll('.shop-the-look-modal__product-btn')).forEach(function (button) {
      var label = button.querySelector('.shop-the-look-modal__product-btn-text');
      if (label) label.textContent = text;
      var aria = button.getAttribute('aria-label');
      if (aria && aria.indexOf(': ') !== -1) {
        button.setAttribute('aria-label', text + aria.slice(aria.indexOf(': ')));
      }
    });
  }

  function normalize(value) {
    return String(value || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  }

  // Categoría de joya según sus etiquetas (Arete, Collar, Pulsera…); '' si no tiene ninguna conocida.
  var LOOK_GROUPS = /^(arete|collar|pulsera|anillo|tobillera|brazalete|choker|dije|cadena|broche|piercing)/;
  function lookGroup(tags) {
    var match = '';
    String(tags || '').split('|').some(function (tag) {
      var found = normalize(tag).match(LOOK_GROUPS);
      if (found) match = found[1];
      return !!found;
    });
    return match;
  }

  // Look por categorías: qué piezas completan cada joya y de qué colección salen (mismo metal si se sabe).
  var LOOK_COMPLEMENTS = {
    arete: ['collares', 'pulseras'],
    collar: ['aretes', 'pulseras'],
    pulsera: ['anillos', 'aretes'],
    anillo: ['pulseras', 'aretes'],
    tobillera: ['pulseras', 'aretes'],
    brazalete: ['anillos', 'aretes'],
    choker: ['aretes', 'pulseras'],
    dije: ['aretes', 'pulseras'],
    cadena: ['aretes', 'pulseras'],
    broche: ['aretes', 'collares'],
    piercing: ['aretes', 'collares']
  };
  var LOOK_METAL_SUFFIX = {
    dorado: { aretes: 'aretes-dorados', collares: 'collares-dorados', pulseras: 'pulseras-doradas', anillos: 'anillos-dorados' },
    plateado: { aretes: 'aretes-plateados', collares: 'collares-plateados', pulseras: 'pulseras-plateadas', anillos: 'anillos-plateados' }
  };

  function lookMetal(text) {
    var value = normalize(text);
    if (/platead|plata/.test(value)) return 'plateado';
    if (/dorad|\boro\b/.test(value)) return 'dorado';
    return '';
  }

  function lookCollectionUrl(category, metal) {
    var handle = (LOOK_METAL_SUFFIX[metal] && LOOK_METAL_SUFFIX[metal][category]) || (category + '-para-mujer');
    return '/collections/' + handle + '?sort_by=best-selling&section_id=api-enova-complete-look';
  }

  function fetchLookItems(url) {
    return fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        return toArray(new DOMParser().parseFromString(html, 'text/html').querySelectorAll('[data-enova-look-api-item]'));
      })
      .catch(function () { return []; });
  }

  function loadRecommendations(block) {
    var url = block.dataset.lookUrl;
    var list = block.querySelector('[data-look-list]');
    if (!url || !list || block.dataset.lookLoaded) return;
    block.dataset.lookLoaded = 'loading';

    var limit = parseInt(block.dataset.lookLimit, 10) || 3;
    var currentId = String(block.dataset.lookProductId || '');

    var lookGroupCurrent = lookGroup(block.dataset.lookTags);
    var lookCategories = LOOK_COMPLEMENTS[lookGroupCurrent] || [];
    var metal = lookMetal(block.dataset.lookTitle + ' ' + block.dataset.lookTags);
    // Desfase estable por producto: cada joya propone piezas distintas de los más vendidos
    var offset = (parseInt(currentId.slice(-4), 10) || 0);

    Promise.all([fetchLookItems(url)].concat(lookCategories.map(function (category) {
      return fetchLookItems(lookCollectionUrl(category, metal));
    })))
      .then(function (lists) {
        var apiItems = lists[0];
        var categoryPicks = lists.slice(1).map(function (items) {
          items = items.filter(function (item) {
            return item.dataset.productId !== currentId && item.firstElementChild;
          });
          return items.length ? [items[offset % items.length]] : [];
        });
        return { apiItems: apiItems, categoryPicks: [].concat.apply([], categoryPicks) };
      })
      .then(function (result) {
        var count = 0;
        var fragment = document.createDocumentFragment();
        var used = {};

        // En una joya solo se sugieren joyas (el tipo "Joyería" también agrupa cajas, vinchas y cepillos,
        // así que se usa la categoría de sus etiquetas) y, primero, las de otra categoría: un arete sugiere
        // collar o pulsera antes que otro arete. En el resto de productos se exige el mismo tipo.
        var currentGroup = lookGroup(block.dataset.lookTags);
        var currentType = normalize(block.dataset.lookType);
        var currentTitle = normalize(block.dataset.lookTitle);
        var items = result.apiItems.filter(function (item) {
          if (item.dataset.productId === currentId || !item.firstElementChild) return false;
          if (currentTitle && normalize(item.dataset.productTitle) === currentTitle) return false;
          if (currentGroup) return lookGroup(item.dataset.productTags) !== '';
          return !currentType || normalize(item.dataset.productType) === currentType;
        });
        var others = items.filter(function (item) { return !currentGroup || lookGroup(item.dataset.productTags) !== currentGroup; });
        var same = items.filter(function (item) { return others.indexOf(item) === -1; });

        // Primero el look por categorías; si falta algo, la recomendación filtrada de Shopify
        result.categoryPicks.concat(others, same).some(function (item) {
          if (used[item.dataset.productId]) return false;
          used[item.dataset.productId] = true;
          fragment.appendChild(document.importNode(item.firstElementChild, true));
          count += 1;
          return count >= limit;
        });

        if (!count) {
          block.dataset.lookLoaded = 'empty';
          collapseLookBlock(block);
          return;
        }

        applyButtonText(fragment, block.dataset.lookButtonText);
        toArray(fragment.children).forEach(function (row) {
          row.classList.add('enova-pdp__look-reveal');
        });
        list.innerHTML = '';
        list.appendChild(fragment);
        block.removeAttribute('aria-busy');
        block.dataset.lookLoaded = 'true';
        // Doble rAF: el estado inicial (opacity 0) se pinta antes de animar
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            toArray(list.children).forEach(function (row) {
              row.classList.add('is-revealed');
            });
          });
        });
      })
      .catch(function () {
        block.dataset.lookLoaded = 'error';
        collapseLookBlock(block);
      });
  }

  // Sin recomendaciones: se pliega el bloque (y el separador que lo sigue) con transición en vez de desaparecer de golpe
  function collapseLookBlock(block) {
    block.removeAttribute('aria-busy');
    var targets = [block];
    var next = block.nextElementSibling;
    if (next && next.classList.contains('enova-pdp__separator')) targets.push(next);

    targets.forEach(function (el) {
      el.style.height = el.offsetHeight + 'px';
      el.style.overflow = 'hidden';
      el.classList.add('enova-pdp__look-collapsing');
    });
    window.requestAnimationFrame(function () {
      targets.forEach(function (el) {
        el.style.height = '0px';
        el.style.opacity = '0';
        el.style.marginTop = '0px';
        el.style.marginBottom = '0px';
        el.style.paddingTop = '0px';
        el.style.paddingBottom = '0px';
      });
    });
    window.setTimeout(function () {
      targets.forEach(function (el) {
        el.hidden = true;
        el.removeAttribute('style');
        el.classList.remove('enova-pdp__look-collapsing');
      });
    }, 360);
  }

  function initCompleteLook(root) {
    if (!root || root.dataset.enovaLookInit) return;
    root.dataset.enovaLookInit = '1';

    var blocks = toArray(root.querySelectorAll(BLOCK_SELECTOR));
    if (!blocks.length) return;

    bindDocument();

    blocks.forEach(function (block) {
      if (block.dataset.lookBound) return;
      block.dataset.lookBound = '1';
      block.addEventListener('click', onBlockClick);
      if (block.dataset.lookUrl) loadRecommendations(block);
    });
  }

  if (window.EnovaPDP && typeof window.EnovaPDP.register === 'function') {
    window.EnovaPDP.register(initCompleteLook);
  } else {
    // Respaldo si enova-product.js no llegó a cargar
    var boot = function () {
      toArray(document.querySelectorAll('[data-enova-pdp]')).forEach(initCompleteLook);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-enova-pdp]');
      if (root) initCompleteLook(root);
    });
  }
})();


/* ==== PDP v2 · media ==== */
/*
 * Bloque "Como se ve en" (looks_videos): miniaturas + modal de video con anterior/siguiente.
 * - Los videos no se cargan hasta el clic (cada miniatura tiene su <video> en un <template>).
 * - Bloqueo de scroll SIN tocar overflow de html/body (no hay salto por el ancho del scrollbar):
 *   wheel/touchmove con preventDefault sobre el overlay, teclas de scroll bloqueadas y un
 *   guardia que restaura la posición si algo desplaza la ventana mientras el modal está abierto.
 */
(function () {
  'use strict';

  var active = null; // controlador del modal abierto (solo uno a la vez)
  var docBound = false;
  var SCROLL_KEYS = { ArrowUp: 1, ArrowDown: 1, PageUp: 1, PageDown: 1, Home: 1, End: 1, ' ': 1, Spacebar: 1 };

  function noop() {}

  function stopEvent(event) {
    if (event.cancelable) event.preventDefault();
  }

  function focusNoScroll(el) {
    if (!el || typeof el.focus !== 'function') return;
    try {
      el.focus({ preventScroll: true });
    } catch (e) {
      el.focus();
    }
  }

  function restoreScroll(x, y) {
    if (window.scrollX === x && window.scrollY === y) return;
    try {
      window.scrollTo({ left: x, top: y, behavior: 'instant' });
    } catch (e) {
      window.scrollTo(x, y);
    }
  }

  function isVisible(el) {
    return !!(el && !el.hidden && el.getClientRects().length);
  }

  function getFocusable(modal) {
    var nodes = modal.querySelectorAll('button:not([disabled]), video[controls], [href], [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(nodes, isVisible);
  }

  function bindDocument() {
    if (docBound) return;
    docBound = true;

    document.addEventListener('keydown', function (event) {
      if (!active) return;
      var key = event.key;
      var target = event.target;
      var onVideo = target && target.tagName === 'VIDEO';

      if (key === 'Escape' || key === 'Esc') {
        event.preventDefault();
        active.close();
        return;
      }

      if ((key === 'ArrowLeft' || key === 'ArrowRight') && !onVideo) {
        event.preventDefault();
        active.go(key === 'ArrowLeft' ? -1 : 1);
        return;
      }

      if (key === 'Tab') {
        var focusable = getFocusable(active.modal);
        if (!focusable.length) {
          event.preventDefault();
          return;
        }
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        var inside = active.modal.contains(document.activeElement);
        if (event.shiftKey && (document.activeElement === first || !inside)) {
          event.preventDefault();
          focusNoScroll(last);
        } else if (!event.shiftKey && (document.activeElement === last || !inside)) {
          event.preventDefault();
          focusNoScroll(first);
        }
        return;
      }

      // Evita que flechas/Av Pág/Espacio desplacen la página de fondo.
      if (SCROLL_KEYS[key] && !onVideo) {
        var isButton = target && target.tagName === 'BUTTON';
        if ((key === ' ' || key === 'Spacebar') && isButton) return;
        event.preventDefault();
      }
    });

    window.addEventListener('scroll', function () {
      if (active) restoreScroll(active.scrollX, active.scrollY);
    }, { passive: true });

    document.addEventListener('shopify:section:unload', function (event) {
      if (active && event.target && event.target.contains(active.block)) active.close(true);
    });

    document.addEventListener('shopify:block:deselect', function () {
      if (active) active.close(true);
    });
  }

  function createController(block) {
    var modal = block.querySelector('[data-enova-looks-modal]');
    var stage = modal && modal.querySelector('[data-enova-looks-stage]');
    var thumbs = Array.prototype.slice.call(block.querySelectorAll('[data-enova-looks-open]'));
    if (!modal || !stage || !thumbs.length) return null;

    var templates = thumbs.map(function (thumb) {
      var item = thumb.parentNode;
      return item ? item.querySelector('template[data-enova-looks-template]') : null;
    });
    var closeBtn = modal.querySelector('[data-enova-looks-close]');
    var prevBtn = modal.querySelector('[data-enova-looks-prev]');
    var nextBtn = modal.querySelector('[data-enova-looks-next]');
    var counter = modal.querySelector('[data-enova-looks-counter]');
    var total = thumbs.length;
    var home = document.createComment('enova-looks-modal');
    modal.parentNode.insertBefore(home, modal);

    var ctrl = {
      block: block,
      modal: modal,
      index: 0,
      scrollX: 0,
      scrollY: 0,
      lastFocus: null,
      video: null
    };

    function removeVideo() {
      var video = ctrl.video;
      ctrl.video = null;
      if (video) {
        try {
          video.pause();
          video.removeAttribute('src');
          Array.prototype.forEach.call(video.querySelectorAll('source'), function (source) {
            source.removeAttribute('src');
          });
          video.load(); // corta la descarga en curso
        } catch (e) { /* noop */ }
      }
      stage.innerHTML = '';
    }

    function playVideo(video) {
      var attempt;
      try {
        video.muted = false;
        attempt = video.play();
      } catch (e) {
        attempt = null;
      }
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(function (error) {
          // Si el navegador bloquea el audio, reproducir en silencio (el usuario puede activarlo).
          if (error && error.name === 'NotAllowedError' && ctrl.video === video) {
            video.muted = true;
            var retry = video.play();
            if (retry && typeof retry.catch === 'function') retry.catch(noop);
          }
        });
      }
    }

    function show(index) {
      index = ((index % total) + total) % total;
      ctrl.index = index;
      removeVideo();

      var tpl = templates[index];
      if (tpl && tpl.content) {
        stage.appendChild(tpl.content.cloneNode(true));
      }
      var video = stage.querySelector('video');
      if (video) {
        ctrl.video = video;
        video.setAttribute('playsinline', '');
        playVideo(video);
      }

      if (counter) counter.textContent = total > 1 ? (index + 1) + ' / ' + total : '';
    }

    ctrl.go = function (step) {
      if (total < 2) return;
      show(ctrl.index + step);
    };

    ctrl.open = function (index, trigger) {
      if (active && active !== ctrl) active.close(true);
      bindDocument();

      ctrl.lastFocus = trigger || document.activeElement;
      ctrl.scrollX = window.scrollX;
      ctrl.scrollY = window.scrollY;

      modal.classList.toggle('enova-pdp-looks-modal--single', total < 2);
      document.body.appendChild(modal); // fuera de cualquier contexto de apilamiento del PDP
      modal.hidden = false;
      document.documentElement.classList.add('enova-looks-modal-open');
      active = ctrl;
      show(index);

      // Forzar reflow para que la transición de entrada se ejecute.
      void modal.offsetWidth;
      modal.classList.add('is-open');
      focusNoScroll(closeBtn);
    };

    ctrl.close = function (skipFocus) {
      if (active !== ctrl) return;
      active = null;
      removeVideo();
      modal.classList.remove('is-open');
      modal.hidden = true;
      document.documentElement.classList.remove('enova-looks-modal-open');
      if (home.parentNode) {
        home.parentNode.insertBefore(modal, home.nextSibling);
      }
      restoreScroll(ctrl.scrollX, ctrl.scrollY);
      if (!skipFocus && ctrl.lastFocus && document.contains(ctrl.lastFocus)) {
        focusNoScroll(ctrl.lastFocus);
      }
      ctrl.lastFocus = null;
    };

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function (event) {
        event.preventDefault();
        ctrl.open(i, thumb);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', function () { ctrl.close(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { ctrl.go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { ctrl.go(1); });

    modal.addEventListener('click', function (event) {
      var target = event.target;
      if (target && target.hasAttribute && target.hasAttribute('data-enova-looks-backdrop')) ctrl.close();
    });

    // El contenido del modal no se desplaza: bloquear rueda y gestos táctiles sin elegir eje.
    modal.addEventListener('wheel', stopEvent, { passive: false });
    modal.addEventListener('touchmove', stopEvent, { passive: false });

    return ctrl;
  }

  function initLooksVideos(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-enova-looks]').forEach(function (block) {
      if (block.dataset.enovaLooksInit) return;
      block.dataset.enovaLooksInit = '1';
      createController(block);
    });
  }

  if (window.EnovaPDP && typeof window.EnovaPDP.register === 'function') {
    window.EnovaPDP.register(initLooksVideos);
  } else {
    // Respaldo si enova-product.js no se cargó: inicializar por cuenta propia.
    var initAll = function () {
      document.querySelectorAll('[data-enova-pdp]').forEach(initLooksVideos);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (event) {
      initLooksVideos(event.target);
    });
  }
})();

/* ==== PDP · Comprar ahora (Tikual) ==== */
/*
 * [data-enova-buy-now] agrega con el botón principal del mismo bloque (mismo flujo del tema) y,
 * cuando el minicarrito confirma el producto agregado, pulsa «Continuar» para abrir directamente
 * los datos de envío del checkout Enova. Si el carrito no llega al monto mínimo, se queda en el
 * minicarrito con su aviso.
 */
(function () {
  'use strict';

  var pendingSince = 0;

  function openCheckoutStep(attempt) {
    var next = document.querySelector('[data-minicart-next]');
    var drawerOpen = document.querySelector('cart-drawer.is-open, .drawer--cart.is-open, [data-cart-drawer].is-open, .cart-drawer.is-open');
    var ready = next && !next.disabled && next.offsetParent !== null && next.getAttribute('aria-disabled') !== 'true';
    if (ready && (drawerOpen || attempt > 3)) {
      next.click();
      return;
    }
    if (attempt < 30) {
      window.setTimeout(function () { openCheckoutStep(attempt + 1); }, 100);
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-enova-buy-now]');
    if (!trigger || trigger.disabled) return;
    var block = trigger.closest('[data-enova-pdp-atc]');
    var addButton = block && block.querySelector('[data-add-to-cart]');
    if (!addButton || addButton.disabled) return;
    event.preventDefault();
    pendingSince = Date.now();
    addButton.click();
  });

  // El minicarrito se vuelve a pintar (CartItems.build) una o dos veces tras agregar y cada
  // repintado cierra la hoja de datos: se espera a que deje de cambiar antes de pulsar «Continuar».
  function whenCartSettles(callback) {
    var drawer = document.querySelector('cart-drawer') || document.body;
    var quietTimer;
    var maxTimer;
    var observer = new MutationObserver(function () {
      window.clearTimeout(quietTimer);
      quietTimer = window.setTimeout(done, 450);
    });
    function done() {
      observer.disconnect();
      window.clearTimeout(quietTimer);
      window.clearTimeout(maxTimer);
      callback();
    }
    observer.observe(drawer, { childList: true, subtree: true });
    quietTimer = window.setTimeout(done, 450);
    maxTimer = window.setTimeout(done, 3000);
  }

  document.addEventListener('theme:product:added', function () {
    if (!pendingSince || Date.now() - pendingSince > 10000) return;
    pendingSince = 0;
    whenCartSettles(function () { openCheckoutStep(0); });
  });

  document.addEventListener('theme:product:added:below_min', function () {
    pendingSince = 0;
  });
})();
